import { Dictionary } from 'typescript-collections';
import _ from 'lodash';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$w =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$x = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$w = fails$x;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$w(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$v = fails$x;

var functionBindNative = !fails$v(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$q = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$q.bind(call$q) : function () {
  return call$q.apply(call$q, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$6 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$p = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$p, call$p);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$p.apply(fn, arguments);
  };
};

var uncurryThis$A = functionUncurryThis;

var toString$f = uncurryThis$A({}.toString);
var stringSlice$b = uncurryThis$A(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$b(toString$f(it), 8, -1);
};

var uncurryThis$z = functionUncurryThis;
var fails$u = fails$x;
var classof$d = classofRaw$2;

var $Object$4 = Object;
var split$3 = uncurryThis$z(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$u(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$d(it) === 'String' ? split$3(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$7 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$6 = isNullOrUndefined$7;

var $TypeError$g = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$b = function (it) {
  if (isNullOrUndefined$6(it)) throw new $TypeError$g("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$a = requireObjectCoercible$b;

var toIndexedObject$6 = function (it) {
  return IndexedObject$2(requireObjectCoercible$a(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$p = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$o = isCallable$p;

var isObject$g = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$o(it);
};

var global$v = global$w;
var isCallable$n = isCallable$p;

var aFunction = function (argument) {
  return isCallable$n(argument) ? argument : undefined;
};

var getBuiltIn$7 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$v[namespace]) : global$v[namespace] && global$v[namespace][method];
};

var uncurryThis$y = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$y({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$u = global$w;
var userAgent$5 = engineUserAgent;

var process$3 = global$u.process;
var Deno$1 = global$u.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$t = fails$x;
var global$t = global$w;

var $String$6 = global$t.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$t(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$6(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$6 = getBuiltIn$7;
var isCallable$m = isCallable$p;
var isPrototypeOf$6 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$3 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$m($Symbol) && isPrototypeOf$6($Symbol.prototype, $Object$3(it));
};

var $String$5 = String;

var tryToString$6 = function (argument) {
  try {
    return $String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$l = isCallable$p;
var tryToString$5 = tryToString$6;

var $TypeError$f = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$a = function (argument) {
  if (isCallable$l(argument)) return argument;
  throw new $TypeError$f(tryToString$5(argument) + ' is not a function');
};

var aCallable$9 = aCallable$a;
var isNullOrUndefined$5 = isNullOrUndefined$7;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$6 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$5(func) ? undefined : aCallable$9(func);
};

var call$o = functionCall;
var isCallable$k = isCallable$p;
var isObject$f = isObject$g;

var $TypeError$e = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$k(fn = input.toString) && !isObject$f(val = call$o(fn, input))) return val;
  if (isCallable$k(fn = input.valueOf) && !isObject$f(val = call$o(fn, input))) return val;
  if (pref !== 'string' && isCallable$k(fn = input.toString) && !isObject$f(val = call$o(fn, input))) return val;
  throw new $TypeError$e("Can't convert object to primitive value");
};

var shared$4 = {exports: {}};

var isPure = false;

var global$s = global$w;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$s, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$s[key] = value;
  } return value;
};

var global$r = global$w;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$r[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.35.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.35.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$9 = requireObjectCoercible$b;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$9 = function (argument) {
  return $Object$2(requireObjectCoercible$9(argument));
};

var uncurryThis$x = functionUncurryThis;
var toObject$8 = toObject$9;

var hasOwnProperty = uncurryThis$x({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$8(it), key);
};

var uncurryThis$w = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$e = uncurryThis$w(1.0.toString);

var uid$3 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$e(++id + postfix, 36);
};

var global$q = global$w;
var shared$3 = shared$4.exports;
var hasOwn$f = hasOwnProperty_1;
var uid$2 = uid$3;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$1 = global$q.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$2;

var wellKnownSymbol$m = function (name) {
  if (!hasOwn$f(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$f(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$n = functionCall;
var isObject$e = isObject$g;
var isSymbol$2 = isSymbol$3;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$l = wellKnownSymbol$m;

var $TypeError$d = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$l('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$2 = function (input, pref) {
  if (!isObject$e(input) || isSymbol$2(input)) return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$n(exoticToPrim, input, pref);
    if (!isObject$e(result) || isSymbol$2(result)) return result;
    throw new $TypeError$d("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive$1 = toPrimitive$2;
var isSymbol$1 = isSymbol$3;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$4 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol$1(key) ? key : key + '';
};

var global$p = global$w;
var isObject$d = isObject$g;

var document$3 = global$p.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$d(document$3) && isObject$d(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$i = descriptors;
var fails$s = fails$x;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$i && !fails$s(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$h = descriptors;
var call$m = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;
var toIndexedObject$5 = toIndexedObject$6;
var toPropertyKey$3 = toPropertyKey$4;
var hasOwn$e = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$h ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$5(O);
  P = toPropertyKey$3(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$e(O, P)) return createPropertyDescriptor$5(!call$m(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$g = descriptors;
var fails$r = fails$x;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$g && fails$r(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$c = isObject$g;

var $String$4 = String;
var $TypeError$c = TypeError;

// `Assert: Type(argument) is Object`
var anObject$j = function (argument) {
  if (isObject$c(argument)) return argument;
  throw new $TypeError$c($String$4(argument) + ' is not an object');
};

var DESCRIPTORS$f = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$i = anObject$j;
var toPropertyKey$2 = toPropertyKey$4;

var $TypeError$b = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$f ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$i(O);
  P = toPropertyKey$2(P);
  anObject$i(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$i(O);
  P = toPropertyKey$2(P);
  anObject$i(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$b('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$e = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;

var createNonEnumerableProperty$8 = DESCRIPTORS$e ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$4(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$d = descriptors;
var hasOwn$d = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$d && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$d(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$d || (DESCRIPTORS$d && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$v = functionUncurryThis;
var isCallable$j = isCallable$p;
var store$1 = sharedStore;

var functionToString = uncurryThis$v(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$j(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$o = global$w;
var isCallable$i = isCallable$p;

var WeakMap$1 = global$o.WeakMap;

var weakMapBasicDetection = isCallable$i(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4.exports;
var uid$1 = uid$3;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid$1(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$n = global$w;
var isObject$b = isObject$g;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$8;
var hasOwn$c = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$5 = global$n.TypeError;
var WeakMap = global$n.WeakMap;
var set$2, get$1, has;

var enforce = function (it) {
  return has(it) ? get$1(it) : set$2(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$b(it) || (state = get$1(it)).type !== TYPE) {
      throw new TypeError$5('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$2 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$5(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$2 = function (it, metadata) {
    if (hasOwn$c(it, STATE)) throw new TypeError$5(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$7(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwn$c(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$c(it, STATE);
  };
}

var internalState = {
  set: set$2,
  get: get$1,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$u = functionUncurryThis;
var fails$q = fails$x;
var isCallable$h = isCallable$p;
var hasOwn$b = hasOwnProperty_1;
var DESCRIPTORS$c = descriptors;
var CONFIGURABLE_FUNCTION_NAME$2 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$8 = internalState;

var enforceInternalState$2 = InternalStateModule$8.enforce;
var getInternalState$5 = InternalStateModule$8.get;
var $String$3 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$a = uncurryThis$u(''.slice);
var replace$7 = uncurryThis$u(''.replace);
var join$3 = uncurryThis$u([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$c && !fails$q(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$a($String$3(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$7($String$3(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$b(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$2 && value.name !== name)) {
    if (DESCRIPTORS$c) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$b(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$b(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$c) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState$2(value);
  if (!hasOwn$b(state, 'source')) {
    state.source = join$3(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$h(this) && getInternalState$5(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$g = isCallable$p;
var definePropertyModule$4 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$b = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$g(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$4.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$7 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$7 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$9 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$8 = toIntegerOrInfinity$9;

var max$1 = Math.max;
var min$5 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$3 = function (index, length) {
  var integer = toIntegerOrInfinity$8(index);
  return integer < 0 ? max$1(integer + length, 0) : min$5(integer, length);
};

var toIntegerOrInfinity$7 = toIntegerOrInfinity$9;

var min$4 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$a = function (argument) {
  var len = toIntegerOrInfinity$7(argument);
  return len > 0 ? min$4(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$9 = toLength$a;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$9 = function (obj) {
  return toLength$9(obj.length);
};

var toIndexedObject$4 = toIndexedObject$6;
var toAbsoluteIndex$2 = toAbsoluteIndex$3;
var lengthOfArrayLike$8 = lengthOfArrayLike$9;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$4($this);
    var length = lengthOfArrayLike$8(O);
    var index = toAbsoluteIndex$2(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$t = functionUncurryThis;
var hasOwn$a = hasOwnProperty_1;
var toIndexedObject$3 = toIndexedObject$6;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$7 = uncurryThis$t([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$3(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$a(hiddenKeys$2, key) && hasOwn$a(O, key) && push$7(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$a(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$7(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$5 = getBuiltIn$7;
var uncurryThis$s = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$h = anObject$j;

var concat$2 = uncurryThis$s([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$h(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$9 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$3 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$9(target, key) && !(exceptions && hasOwn$9(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$p = fails$x;
var isCallable$f = isCallable$p;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$f(detection) ? fails$p(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$m = global$w;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$8;
var defineBuiltIn$a = defineBuiltIn$b;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$2 = copyConstructorProperties$3;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$m;
  } else if (STATIC) {
    target = global$m[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$m[TARGET] && global$m[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$3(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$2(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$6(sourceProperty, 'sham', true);
    }
    defineBuiltIn$a(target, key, sourceProperty, options);
  }
};

var wellKnownSymbol$k = wellKnownSymbol$m;

var TO_STRING_TAG$3 = wellKnownSymbol$k('toStringTag');
var test$2 = {};

test$2[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test$2) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$e = isCallable$p;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$j = wellKnownSymbol$m;

var TO_STRING_TAG$2 = wellKnownSymbol$j('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$c = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$e(O.callee) ? 'Arguments' : result;
};

var classof$b = classof$c;

var $String$2 = String;

var toString$d = function (argument) {
  if (classof$b(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$2(argument);
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$4 = objectDefineProperty;

var defineBuiltInAccessor$7 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$4.f(target, name, descriptor);
};

var $$k = _export;
var DESCRIPTORS$b = descriptors;
var global$l = global$w;
var uncurryThis$r = functionUncurryThis;
var hasOwn$8 = hasOwnProperty_1;
var isCallable$d = isCallable$p;
var isPrototypeOf$5 = objectIsPrototypeOf;
var toString$c = toString$d;
var defineBuiltInAccessor$6 = defineBuiltInAccessor$7;
var copyConstructorProperties$1 = copyConstructorProperties$3;

var NativeSymbol = global$l.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$b && isCallable$d(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$c(arguments[0]);
    var result = isPrototypeOf$5(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties$1(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$r(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$r(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$6 = uncurryThis$r(''.replace);
  var stringSlice$9 = uncurryThis$r(''.slice);

  defineBuiltInAccessor$6(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$8(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$9(string, 7, -1) : replace$6(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$k({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

class FileModel {
  constructor(src = null, type = null) {
    this.id = "";
    this.name = "";
    this.size = 0;
    this.type = "";
    this.src = "";
    this.enabled = false;
    this.description = null;
    this.lastModified = new Date();
    this.isFileModel = true;
    this.originalId = null;
    this.isUploading = null;
    this.src = src || "";
    this.type = type || "";
  }
}

class GeoCoordinate {
  constructor(latitude = null, longitude = null) {
    this.lat = 0.0;
    this.lon = 0.0;
    this.isGeoCoordinate = true;
    this.lat = latitude || 0.0;
    this.lon = longitude || 0.0;
  }
}

var objectDefineProperties = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$a = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$g = anObject$j;
var toIndexedObject$2 = toIndexedObject$6;
var objectKeys$1 = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$a && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$g(O);
  var props = toIndexedObject$2(Properties);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$4 = getBuiltIn$7;

var html$2 = getBuiltIn$4('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$f = anObject$j;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject$f(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$i = wellKnownSymbol$m;
var create$4 = objectCreate;
var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$i('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$4(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$o = fails$x;

var correctPrototypeGetter = !fails$o(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$7 = hasOwnProperty_1;
var isCallable$c = isCallable$p;
var toObject$7 = toObject$9;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype$2 = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$7(O);
  if (hasOwn$7(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$c(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype$2 : null;
};

var fails$n = fails$x;
var isCallable$b = isCallable$p;
var isObject$a = isObject$g;
var getPrototypeOf$3 = objectGetPrototypeOf;
var defineBuiltIn$9 = defineBuiltIn$b;
var wellKnownSymbol$h = wellKnownSymbol$m;

var ITERATOR$7 = wellKnownSymbol$h('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$3(getPrototypeOf$3(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$a(IteratorPrototype$2) || fails$n(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$7].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$2[ITERATOR$7])) {
  defineBuiltIn$9(IteratorPrototype$2, ITERATOR$7, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;
var hasOwn$6 = hasOwnProperty_1;
var wellKnownSymbol$g = wellKnownSymbol$m;

var TO_STRING_TAG$1 = wellKnownSymbol$g('toStringTag');

var setToStringTag$7 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$6(target, TO_STRING_TAG$1)) {
    defineProperty$2(target, TO_STRING_TAG$1, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$3 = objectCreate;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;
var setToStringTag$6 = setToStringTag$7;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$3(IteratorPrototype$1, { next: createPropertyDescriptor$3(+!ENUMERABLE_NEXT, next) });
  setToStringTag$6(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$q = functionUncurryThis;
var aCallable$8 = aCallable$a;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$q(aCallable$8(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$9 = isObject$g;

var isPossiblePrototype$1 = function (argument) {
  return isObject$9(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$1 = String;
var $TypeError$a = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$a("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var anObject$e = anObject$j;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$e(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$j = _export;
var call$l = functionCall;
var FunctionName$1 = functionName;
var isCallable$a = isCallable$p;
var createIteratorConstructor$1 = iteratorCreateConstructor;
var getPrototypeOf$2 = objectGetPrototypeOf;
var setPrototypeOf$5 = objectSetPrototypeOf;
var setToStringTag$5 = setToStringTag$7;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$8;
var defineBuiltIn$8 = defineBuiltIn$b;
var wellKnownSymbol$f = wellKnownSymbol$m;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$3 = FunctionName$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = FunctionName$1.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol$f('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$2(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$5) {
          setPrototypeOf$5(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$a(CurrentIteratorPrototype[ITERATOR$6])) {
          defineBuiltIn$8(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$5(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$3 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty$5(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$l(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$8(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$j({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    defineBuiltIn$8(IterablePrototype, ITERATOR$6, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$3 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject$1 = toIndexedObject$6;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$7 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator$1 = iteratorDefine;
var createIterResultObject$2 = createIterResultObject$3;
var DESCRIPTORS$9 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$6 = InternalStateModule$7.set;
var getInternalState$4 = InternalStateModule$7.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$6(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$1(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$4(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject$2(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$2(index, false);
    case 'values': return createIterResultObject$2(target[index], false);
  } return createIterResultObject$2([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$9 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$k = global$w;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$8;
var setToStringTag$4 = setToStringTag$7;
var wellKnownSymbol$e = wellKnownSymbol$m;

var ITERATOR$5 = wellKnownSymbol$e('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5] !== ArrayValues) try {
      createNonEnumerableProperty$4(CollectionPrototype, ITERATOR$5, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$5] = ArrayValues;
    }
    setToStringTag$4(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$4(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$k[COLLECTION_NAME] && global$k[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

class GeoLocation extends GeoCoordinate {
  constructor() {
    super(...arguments);
    this.country = "";
    this.address = "";
    this.city = "";
    this.postalCode = "";
    this.postalBox = "";
    this.formattedAddress = "";
    this.isGeoLocation = true;
  }
}

var $$i = _export;
var $includes = arrayIncludes.includes;
var fails$m = fails$x;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$m(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$i({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var classofRaw = classofRaw$2;
var uncurryThis$p = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$p(fn);
};

// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferBasicDetection = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var defineBuiltIn$7 = defineBuiltIn$b;

var defineBuiltIns$2 = function (target, src, options) {
  for (var key in src) defineBuiltIn$7(target, key, src[key], options);
  return target;
};

var isPrototypeOf$4 = objectIsPrototypeOf;

var $TypeError$9 = TypeError;

var anInstance$5 = function (it, Prototype) {
  if (isPrototypeOf$4(Prototype, it)) return it;
  throw new $TypeError$9('Incorrect invocation');
};

var toIntegerOrInfinity$6 = toIntegerOrInfinity$9;
var toLength$8 = toLength$a;

var $RangeError$5 = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var toIndex$2 = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity$6(it);
  var length = toLength$8(number);
  if (number !== length) throw new $RangeError$5('Wrong length or index');
  return length;
};

// `Math.sign` method implementation
// https://tc39.es/ecma262/#sec-math.sign
// eslint-disable-next-line es/no-math-sign -- safe
var mathSign = Math.sign || function sign(x) {
  var n = +x;
  // eslint-disable-next-line no-self-compare -- NaN check
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
};

var sign = mathSign;

var abs$1 = Math.abs;

var EPSILON = 2.220446049250313e-16; // Number.EPSILON
var INVERSE_EPSILON = 1 / EPSILON;

var roundTiesToEven = function (n) {
  return n + INVERSE_EPSILON - INVERSE_EPSILON;
};

var mathFloatRound = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
  var n = +x;
  var absolute = abs$1(n);
  var s = sign(n);
  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
  var result = a - (a - absolute);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
  return s * result;
};

var floatRound = mathFloatRound;

var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;

// `Math.fround` method implementation
// https://tc39.es/ecma262/#sec-math.fround
// eslint-disable-next-line es/no-math-fround -- safe
var mathFround = Math.fround || function fround(x) {
  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
};

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array$2 = Array;
var abs = Math.abs;
var pow$2 = Math.pow;
var floor$6 = Math.floor;
var log$1 = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array$2(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow$2(2, -24) - pow$2(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number !== number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number !== number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$6(log$1(number) / LN2);
    c = pow$2(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow$2(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow$2(2, mantissaLength);
      exponent += eBias;
    } else {
      mantissa = number * pow$2(2, eBias - 1) * pow$2(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa += pow$2(2, mantissaLength);
    exponent -= eBias;
  } return (sign ? -1 : 1) * mantissa * pow$2(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

var toObject$6 = toObject$9;
var toAbsoluteIndex$1 = toAbsoluteIndex$3;
var lengthOfArrayLike$7 = lengthOfArrayLike$9;

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill$1 = function fill(value /* , start = 0, end = @length */) {
  var O = toObject$6(this);
  var length = lengthOfArrayLike$7(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$1(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex$1(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var uncurryThis$o = functionUncurryThis;

var arraySlice$5 = uncurryThis$o([].slice);

var isCallable$9 = isCallable$p;
var isObject$8 = isObject$g;
var setPrototypeOf$4 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$2 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$4 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$9(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$8(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$4($this, NewTargetPrototype);
  return $this;
};

var global$j = global$w;
var uncurryThis$n = functionUncurryThis;
var DESCRIPTORS$8 = descriptors;
var NATIVE_ARRAY_BUFFER$1 = arrayBufferBasicDetection;
var FunctionName = functionName;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$8;
var defineBuiltInAccessor$5 = defineBuiltInAccessor$7;
var defineBuiltIns$1 = defineBuiltIns$2;
var fails$l = fails$x;
var anInstance$4 = anInstance$5;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$9;
var toLength$7 = toLength$a;
var toIndex$1 = toIndex$2;
var fround = mathFround;
var IEEE754 = ieee754;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$3 = objectSetPrototypeOf;
var arrayFill = arrayFill$1;
var arraySlice$4 = arraySlice$5;
var inheritIfRequired$1 = inheritIfRequired$2;
var copyConstructorProperties = copyConstructorProperties$3;
var setToStringTag$3 = setToStringTag$7;
var InternalStateModule$6 = internalState;

var PROPER_FUNCTION_NAME$2 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH$1 = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule$6.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule$6.getterFor(DATA_VIEW);
var setInternalState$5 = InternalStateModule$6.set;
var NativeArrayBuffer = global$j[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype$1 = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$j[DATA_VIEW];
var DataViewPrototype$1 = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype$1 = Object.prototype;
var Array$1 = global$j.Array;
var RangeError$3 = global$j.RangeError;
var fill = uncurryThis$n(arrayFill);
var reverse = uncurryThis$n([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(fround(number), 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter$1 = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor$5(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex$1(index);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError$3(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice$4(bytes, start, start + count);
  return boolIsLittleEndian ? pack : reverse(pack);
};

var set$1 = function (view, count, index, conversion, value, isLittleEndian) {
  var store = getInternalDataViewState(view);
  var intIndex = toIndex$1(index);
  var pack = conversion(+value);
  var boolIsLittleEndian = !!isLittleEndian;
  if (intIndex + count > store.byteLength) throw new RangeError$3(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER$1) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance$4(this, ArrayBufferPrototype$1);
    var byteLength = toIndex$1(length);
    setInternalState$5(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array$1(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS$8) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype$1 = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance$4(this, DataViewPrototype$1);
    anInstance$4(buffer, ArrayBufferPrototype$1);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity$5(byteOffset);
    if (offset < 0 || offset > bufferLength) throw new RangeError$3('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength$7(byteLength);
    if (offset + byteLength > bufferLength) throw new RangeError$3(WRONG_LENGTH$1);
    setInternalState$5(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS$8) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype$1 = $DataView[PROTOTYPE];

  if (DESCRIPTORS$8) {
    addGetter$1($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter$1($DataView, 'buffer', getInternalDataViewState);
    addGetter$1($DataView, 'byteLength', getInternalDataViewState);
    addGetter$1($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns$1(DataViewPrototype$1, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set$1(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set$1(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set$1(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set$1(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set$1(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set$1(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set$1(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set$1(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME$2 && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails$l(function () {
    NativeArrayBuffer(1);
  }) || !fails$l(function () {
    new NativeArrayBuffer(-1);
  }) || fails$l(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance$4(this, ArrayBufferPrototype$1);
      return inheritIfRequired$1(new NativeArrayBuffer(toIndex$1(length)), this, $ArrayBuffer);
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype$1;

    ArrayBufferPrototype$1.constructor = $ArrayBuffer;

    copyConstructorProperties($ArrayBuffer, NativeArrayBuffer);
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty$3(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf$3 && getPrototypeOf$1(DataViewPrototype$1) !== ObjectPrototype$1) {
    setPrototypeOf$3(DataViewPrototype$1, ObjectPrototype$1);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis$n(DataViewPrototype$1.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns$1(DataViewPrototype$1, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag$3($ArrayBuffer, ARRAY_BUFFER);
setToStringTag$3($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var uncurryThis$m = functionUncurryThis;
var fails$k = fails$x;
var isCallable$8 = isCallable$p;
var classof$a = classof$c;
var getBuiltIn$3 = getBuiltIn$7;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$3 = uncurryThis$m(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$8(argument)) return false;
  switch (classof$a(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$3(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$3 = !construct || fails$k(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$2 = isConstructor$3;
var tryToString$4 = tryToString$6;

var $TypeError$8 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$2 = function (argument) {
  if (isConstructor$2(argument)) return argument;
  throw new $TypeError$8(tryToString$4(argument) + ' is not a constructor');
};

var anObject$d = anObject$j;
var aConstructor$1 = aConstructor$2;
var isNullOrUndefined$4 = isNullOrUndefined$7;
var wellKnownSymbol$d = wellKnownSymbol$m;

var SPECIES$4 = wellKnownSymbol$d('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$3 = function (O, defaultConstructor) {
  var C = anObject$d(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$4(S = anObject$d(C)[SPECIES$4]) ? defaultConstructor : aConstructor$1(S);
};

var $$h = _export;
var uncurryThis$l = functionUncurryThisClause;
var fails$j = fails$x;
var ArrayBufferModule$1 = arrayBuffer;
var anObject$c = anObject$j;
var toAbsoluteIndex = toAbsoluteIndex$3;
var toLength$6 = toLength$a;
var speciesConstructor$2 = speciesConstructor$3;

var ArrayBuffer$3 = ArrayBufferModule$1.ArrayBuffer;
var DataView$2 = ArrayBufferModule$1.DataView;
var DataViewPrototype = DataView$2.prototype;
var nativeArrayBufferSlice = uncurryThis$l(ArrayBuffer$3.prototype.slice);
var getUint8 = uncurryThis$l(DataViewPrototype.getUint8);
var setUint8 = uncurryThis$l(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails$j(function () {
  return !new ArrayBuffer$3(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$$h({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject$c(this), start); // FF fix
    }
    var length = anObject$c(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor$2(this, ArrayBuffer$3))(toLength$6(fin - first));
    var viewSource = new DataView$2(this);
    var viewTarget = new DataView$2(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});

var uncurryThis$k = functionUncurryThis;

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
var thisNumberValue$1 = uncurryThis$k(1.0.valueOf);

var toIntegerOrInfinity$4 = toIntegerOrInfinity$9;
var toString$b = toString$d;
var requireObjectCoercible$8 = requireObjectCoercible$b;

var $RangeError$4 = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
var stringRepeat = function repeat(count) {
  var str = toString$b(requireObjectCoercible$8(this));
  var result = '';
  var n = toIntegerOrInfinity$4(count);
  if (n < 0 || n === Infinity) throw new $RangeError$4('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};

var $$g = _export;
var uncurryThis$j = functionUncurryThis;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$9;
var thisNumberValue = thisNumberValue$1;
var $repeat = stringRepeat;
var fails$i = fails$x;

var $RangeError$3 = RangeError;
var $String = String;
var floor$5 = Math.floor;
var repeat = uncurryThis$j($repeat);
var stringSlice$8 = uncurryThis$j(''.slice);
var nativeToFixed = uncurryThis$j(1.0.toFixed);

var pow$1 = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow$1(x, n - 1, acc * x) : pow$1(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor$5(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor$5(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = $String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED$2 = fails$i(function () {
  return nativeToFixed(0.00008, 3) !== '0.000' ||
    nativeToFixed(0.9, 0) !== '1' ||
    nativeToFixed(1.255, 2) !== '1.25' ||
    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails$i(function () {
  // V8 ~ Android 4.3-
  nativeToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$$g({ target: 'Number', proto: true, forced: FORCED$2 }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity$3(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError$3('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number !== number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return $String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow$1(2, 69, 1)) - 69;
      z = e < 0 ? number * pow$1(2, -e, 1) : number / pow$1(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow$1(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice$8(result, 0, k - fractDigits) + '.' + stringSlice$8(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});

var global$i = global$w;
var classof$9 = classofRaw$2;

var engineIsNode = classof$9(global$i.process) === 'process';

var getBuiltIn$2 = getBuiltIn$7;
var defineBuiltInAccessor$4 = defineBuiltInAccessor$7;
var wellKnownSymbol$c = wellKnownSymbol$m;
var DESCRIPTORS$7 = descriptors;

var SPECIES$3 = wellKnownSymbol$c('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$2(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$7 && Constructor && !Constructor[SPECIES$3]) {
    defineBuiltInAccessor$4(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$3 = FunctionPrototype.apply;
var call$k = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$k.bind(apply$3) : function () {
  return call$k.apply(apply$3, arguments);
});

var uncurryThis$i = functionUncurryThisClause;
var aCallable$7 = aCallable$a;
var NATIVE_BIND = functionBindNative;

var bind$9 = uncurryThis$i(uncurryThis$i.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$7(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$9(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var $TypeError$7 = TypeError;

var validateArgumentsLength$3 = function (passed, required) {
  if (passed < required) throw new $TypeError$7('Not enough arguments');
  return passed;
};

var userAgent$4 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);

var global$h = global$w;
var apply$2 = functionApply;
var bind$8 = functionBindContext;
var isCallable$7 = isCallable$p;
var hasOwn$5 = hasOwnProperty_1;
var fails$h = fails$x;
var html = html$2;
var arraySlice$3 = arraySlice$5;
var createElement = documentCreateElement$2;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set = global$h.setImmediate;
var clear = global$h.clearImmediate;
var process$2 = global$h.process;
var Dispatch = global$h.Dispatch;
var Function$1 = global$h.Function;
var MessageChannel = global$h.MessageChannel;
var String$1 = global$h.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$h(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$h.location;
});

var run = function (id) {
  if (hasOwn$5(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$h.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength$2(arguments.length, 1);
    var fn = isCallable$7(handler) ? handler : Function$1(handler);
    var args = arraySlice$3(arguments, 1);
    queue$2[++counter] = function () {
      apply$2(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$8(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$h.addEventListener &&
    isCallable$7(global$h.postMessage) &&
    !global$h.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$h(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$h.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var global$g = global$w;
var DESCRIPTORS$6 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$2 = function (name) {
  if (!DESCRIPTORS$6) return global$g[name];
  var descriptor = getOwnPropertyDescriptor$2(global$g, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$3 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && typeof Pebble != 'undefined';

var userAgent$2 = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);

var global$f = global$w;
var safeGetBuiltIn$1 = safeGetBuiltIn$2;
var bind$7 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$f.MutationObserver || global$f.WebKitMutationObserver;
var document$2 = global$f.document;
var process$1 = global$f.process;
var Promise$1 = global$f.Promise;
var microtask$1 = safeGetBuiltIn$1('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$7(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$7(macrotask, global$f);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$e = global$w;

var promiseNativeConstructor = global$e.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$d = global$w;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$6 = isCallable$p;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$b = wellKnownSymbol$m;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$2 = wellKnownSymbol$b('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$6(global$d.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$2] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$6 = aCallable$a;

var $TypeError$6 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$6('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$6(resolve);
  this.reject = aCallable$6(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$f = _export;
var IS_NODE = engineIsNode;
var global$c = global$w;
var call$j = functionCall;
var defineBuiltIn$6 = defineBuiltIn$b;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$7;
var setSpecies$1 = setSpecies$2;
var aCallable$5 = aCallable$a;
var isCallable$5 = isCallable$p;
var isObject$7 = isObject$g;
var anInstance$3 = anInstance$5;
var speciesConstructor$1 = speciesConstructor$3;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$5 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$5.getterFor(PROMISE);
var setInternalState$4 = InternalStateModule$5.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$4 = global$c.TypeError;
var document$1 = global$c.document;
var process = global$c.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$c.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$7(it) && isCallable$5(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$4('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$j(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$c.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$c['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$j(task, global$c, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$j(task, global$c, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$6 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$4("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$j(then, value,
            bind$6(internalResolve, wrapper, state),
            bind$6(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$3(this, PromisePrototype);
    aCallable$5(executor);
    call$j(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$6(internalResolve, state), bind$6(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$4(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$6(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$5(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$5(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$6(internalResolve, state);
    this.reject = bind$6(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$5(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$6(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$j(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$2) {
      setPrototypeOf$2(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$f({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

var wellKnownSymbol$a = wellKnownSymbol$m;
var Iterators$1 = iterators;

var ITERATOR$4 = wellKnownSymbol$a('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$3 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$4] === it);
};

var classof$8 = classof$c;
var getMethod$4 = getMethod$6;
var isNullOrUndefined$3 = isNullOrUndefined$7;
var Iterators = iterators;
var wellKnownSymbol$9 = wellKnownSymbol$m;

var ITERATOR$3 = wellKnownSymbol$9('iterator');

var getIteratorMethod$5 = function (it) {
  if (!isNullOrUndefined$3(it)) return getMethod$4(it, ITERATOR$3)
    || getMethod$4(it, '@@iterator')
    || Iterators[classof$8(it)];
};

var call$i = functionCall;
var aCallable$4 = aCallable$a;
var anObject$b = anObject$j;
var tryToString$3 = tryToString$6;
var getIteratorMethod$4 = getIteratorMethod$5;

var $TypeError$5 = TypeError;

var getIterator$4 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$4(argument) : usingIterator;
  if (aCallable$4(iteratorMethod)) return anObject$b(call$i(iteratorMethod, argument));
  throw new $TypeError$5(tryToString$3(argument) + ' is not iterable');
};

var call$h = functionCall;
var anObject$a = anObject$j;
var getMethod$3 = getMethod$6;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$a(iterator);
  try {
    innerResult = getMethod$3(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$h(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$a(innerResult);
  return value;
};

var bind$5 = functionBindContext;
var call$g = functionCall;
var anObject$9 = anObject$j;
var tryToString$2 = tryToString$6;
var isArrayIteratorMethod$2 = isArrayIteratorMethod$3;
var lengthOfArrayLike$6 = lengthOfArrayLike$9;
var isPrototypeOf$3 = objectIsPrototypeOf;
var getIterator$3 = getIterator$4;
var getIteratorMethod$3 = getIteratorMethod$5;
var iteratorClose$1 = iteratorClose$2;

var $TypeError$4 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$2 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$5(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$9(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$3(iterable);
    if (!iterFn) throw new $TypeError$4(tryToString$2(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$2(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$6(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$3(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$3(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$g(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$3(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$8 = wellKnownSymbol$m;

var ITERATOR$2 = wellKnownSymbol$8('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$2 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$2;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration$1(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$e = _export;
var call$f = functionCall;
var aCallable$3 = aCallable$a;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$1 = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$e({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$3(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$1(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$f($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$d = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$7;
var isCallable$4 = isCallable$p;
var defineBuiltIn$5 = defineBuiltIn$b;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$d({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$4(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$5(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$c = _export;
var call$e = functionCall;
var aCallable$2 = aCallable$a;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate = iterate$2;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$c({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      iterate(iterable, function (promise) {
        call$e($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$b = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$b({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$8 = anObject$j;
var isObject$6 = isObject$g;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$8(C);
  if (isObject$6(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$a = _export;
var getBuiltIn = getBuiltIn$7;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$a({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var anObject$7 = anObject$j;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$7(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$g = fails$x;
var global$b = global$w;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$b.RegExp;

var UNSUPPORTED_Y$2 = fails$g(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$2 || fails$g(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$2 || fails$g(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$2
};

var fails$f = fails$x;
var global$a = global$w;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$a.RegExp;

var regexpUnsupportedDotAll = fails$f(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$e = fails$x;
var global$9 = global$w;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$9.RegExp;

var regexpUnsupportedNcg = fails$e(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$d = functionCall;
var uncurryThis$h = functionUncurryThis;
var toString$a = toString$d;
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared = shared$4.exports;
var create$2 = objectCreate;
var getInternalState$3 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$6 = uncurryThis$h(''.charAt);
var indexOf = uncurryThis$h(''.indexOf);
var replace$5 = uncurryThis$h(''.replace);
var stringSlice$7 = uncurryThis$h(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$d(nativeExec, re1, 'a');
  call$d(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$3(re);
    var str = toString$a(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$d(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = call$d(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$5(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$7(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$6(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$d(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$7(match.input, charsAdded);
        match[0] = stringSlice$7(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$d(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$9 = _export;
var exec$2 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$9({ target: 'RegExp', proto: true, forced: /./.exec !== exec$2 }, {
  exec: exec$2
});

var call$c = functionCall;
var hasOwn$4 = hasOwnProperty_1;
var isPrototypeOf$2 = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$2 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$2) && !hasOwn$4(R, 'flags') && isPrototypeOf$2(RegExpPrototype$2, R)
    ? call$c(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var defineBuiltIn$4 = defineBuiltIn$b;
var anObject$6 = anObject$j;
var $toString$2 = toString$d;
var fails$d = fails$x;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$d(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn$4(RegExpPrototype$1, TO_STRING, function toString() {
    var R = anObject$6(this);
    var pattern = $toString$2(R.source);
    var flags = $toString$2(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var isObject$5 = isObject$g;
var classof$7 = classofRaw$2;
var wellKnownSymbol$7 = wellKnownSymbol$m;

var MATCH$1 = wellKnownSymbol$7('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$5(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$7(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$3 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$3("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$6 = wellKnownSymbol$m;

var MATCH = wellKnownSymbol$6('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$8 = _export;
var uncurryThis$g = functionUncurryThisClause;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var toLength$5 = toLength$a;
var toString$9 = toString$d;
var notARegExp$2 = notARegexp;
var requireObjectCoercible$7 = requireObjectCoercible$b;
var correctIsRegExpLogic$2 = correctIsRegexpLogic;

var slice$1 = uncurryThis$g(''.slice);
var min$3 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegExpLogic$2('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$1(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$$8({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString$9(requireObjectCoercible$7(this));
    notARegExp$2(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min$3(toLength$5(endPosition), len);
    var search = toString$9(searchString);
    return slice$1(that, end - search.length, end) === search;
  }
});

var $$7 = _export;
var uncurryThis$f = functionUncurryThis;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$6 = requireObjectCoercible$b;
var toString$8 = toString$d;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$f(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$7({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$8(requireObjectCoercible$6(this)),
      toString$8(notARegExp$1(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$b = functionCall;
var defineBuiltIn$3 = defineBuiltIn$b;
var regexpExec$1 = regexpExec$2;
var fails$c = fails$x;
var wellKnownSymbol$5 = wellKnownSymbol$m;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$8;

var SPECIES$1 = wellKnownSymbol$5('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$5(KEY);

  var DELEGATES_TO_SYMBOL = !fails$c(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$c(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$1] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$b(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$b(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$3(String.prototype, KEY, methods[0]);
    defineBuiltIn$3(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$2(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$e = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$9;
var toString$7 = toString$d;
var requireObjectCoercible$5 = requireObjectCoercible$b;

var charAt$5 = uncurryThis$e(''.charAt);
var charCodeAt$1 = uncurryThis$e(''.charCodeAt);
var stringSlice$6 = uncurryThis$e(''.slice);

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$7(requireObjectCoercible$5($this));
    var position = toIntegerOrInfinity$2(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$5(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$6(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt$4 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$3 = function (S, index, unicode) {
  return index + (unicode ? charAt$4(S, index).length : 1);
};

var call$a = functionCall;
var anObject$5 = anObject$j;
var isCallable$3 = isCallable$p;
var classof$6 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$2 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$3(exec)) {
    var result = call$a(exec, R, S);
    if (result !== null) anObject$5(result);
    return result;
  }
  if (classof$6(R) === 'RegExp') return call$a(regexpExec, R, S);
  throw new $TypeError$2('RegExp#exec called on incompatible receiver');
};

var call$9 = functionCall;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var anObject$4 = anObject$j;
var isNullOrUndefined$2 = isNullOrUndefined$7;
var toLength$4 = toLength$a;
var toString$6 = toString$d;
var requireObjectCoercible$4 = requireObjectCoercible$b;
var getMethod$2 = getMethod$6;
var advanceStringIndex$2 = advanceStringIndex$3;
var regExpExec$2 = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic$2('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$4(this);
      var matcher = isNullOrUndefined$2(regexp) ? undefined : getMethod$2(regexp, MATCH);
      return matcher ? call$9(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString$6(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject$4(this);
      var S = toString$6(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec$2(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec$2(rx, S)) !== null) {
        var matchStr = toString$6(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$4(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var uncurryThis$d = functionUncurryThis;
var toObject$5 = toObject$9;

var floor$4 = Math.floor;
var charAt$3 = uncurryThis$d(''.charAt);
var replace$4 = uncurryThis$d(''.replace);
var stringSlice$5 = uncurryThis$d(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$5(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$4(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$3(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$5(str, 0, position);
      case "'": return stringSlice$5(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$5(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$4(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$3(ch, 1) : captures[f - 1] + charAt$3(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply$1 = functionApply;
var call$8 = functionCall;
var uncurryThis$c = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$b = fails$x;
var anObject$3 = anObject$j;
var isCallable$2 = isCallable$p;
var isNullOrUndefined$1 = isNullOrUndefined$7;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$9;
var toLength$3 = toLength$a;
var toString$5 = toString$d;
var requireObjectCoercible$3 = requireObjectCoercible$b;
var advanceStringIndex$1 = advanceStringIndex$3;
var getMethod$1 = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$4 = wellKnownSymbol$m;

var REPLACE = wellKnownSymbol$4('replace');
var max = Math.max;
var min$2 = Math.min;
var concat$1 = uncurryThis$c([].concat);
var push$6 = uncurryThis$c([].push);
var stringIndexOf = uncurryThis$c(''.indexOf);
var stringSlice$4 = uncurryThis$c(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$b(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = isNullOrUndefined$1(searchValue) ? undefined : getMethod$1(searchValue, REPLACE);
      return replacer
        ? call$8(replacer, searchValue, O, replaceValue)
        : call$8(nativeReplace, toString$5(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$3(this);
      var S = toString$5(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$2(replaceValue);
      if (!functionalReplace) replaceValue = toString$5(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$1(rx, S);
        if (result === null) break;

        push$6(results, result);
        if (!global) break;

        var matchStr = toString$5(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$3(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$5(result[0]);
        var position = max(min$2(toIntegerOrInfinity$1(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$6(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== undefined) push$6(replacerArgs, namedCaptures);
          replacement = toString$5(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var $$6 = _export;
var uncurryThis$b = functionUncurryThisClause;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength$2 = toLength$a;
var toString$4 = toString$d;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$b;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringSlice$3 = uncurryThis$b(''.slice);
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$6({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$4(requireObjectCoercible$2(this));
    notARegExp(searchString);
    var index = toLength$2(min$1(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$4(searchString);
    return stringSlice$3(that, index, index + search.length) === search;
  }
});

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$a = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$b;
var toString$3 = toString$d;
var whitespaces$1 = whitespaces$2;

var replace$3 = uncurryThis$a(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$3(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace$3(string, ltrim, '');
    if (TYPE & 2) string = replace$3(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$a = fails$x;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$a(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$5 = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$5({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

var typedArrayConstructor = {exports: {}};

var NATIVE_ARRAY_BUFFER = arrayBufferBasicDetection;
var DESCRIPTORS$5 = descriptors;
var global$8 = global$w;
var isCallable$1 = isCallable$p;
var isObject$4 = isObject$g;
var hasOwn$3 = hasOwnProperty_1;
var classof$5 = classof$c;
var tryToString$1 = tryToString$6;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$8;
var defineBuiltIn$2 = defineBuiltIn$b;
var defineBuiltInAccessor$3 = defineBuiltInAccessor$7;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var wellKnownSymbol$3 = wellKnownSymbol$m;
var uid = uid$3;
var InternalStateModule$4 = internalState;

var enforceInternalState$1 = InternalStateModule$4.enforce;
var getInternalState$2 = InternalStateModule$4.get;
var Int8Array$4 = global$8.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global$8.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray$1 = Int8Array$4 && getPrototypeOf(Int8Array$4);
var TypedArrayPrototype$1 = Int8ArrayPrototype$1 && getPrototypeOf(Int8ArrayPrototype$1);
var ObjectPrototype = Object.prototype;
var TypeError$3 = global$8.TypeError;

var TO_STRING_TAG = wellKnownSymbol$3('toStringTag');
var TYPED_ARRAY_TAG$1 = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS$2 = NATIVE_ARRAY_BUFFER && !!setPrototypeOf$1 && classof$5(global$8.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject$4(it)) return false;
  var klass = classof$5(it);
  return klass === 'DataView'
    || hasOwn$3(TypedArrayConstructorsList, klass)
    || hasOwn$3(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject$4(proto)) return;
  var state = getInternalState$2(proto);
  return (state && hasOwn$3(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray$1 = function (it) {
  if (!isObject$4(it)) return false;
  var klass = classof$5(it);
  return hasOwn$3(TypedArrayConstructorsList, klass)
    || hasOwn$3(BigIntArrayConstructorsList, klass);
};

var aTypedArray$4 = function (it) {
  if (isTypedArray$1(it)) return it;
  throw new TypeError$3('Target is not a typed array');
};

var aTypedArrayConstructor$1 = function (C) {
  if (isCallable$1(C) && (!setPrototypeOf$1 || isPrototypeOf$1(TypedArray$1, C))) return C;
  throw new TypeError$3(tryToString$1(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod$4 = function (KEY, property, forced, options) {
  if (!DESCRIPTORS$5) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global$8[ARRAY];
    if (TypedArrayConstructor && hasOwn$3(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype$1[KEY] || forced) {
    defineBuiltIn$2(TypedArrayPrototype$1, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS$2 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS$5) return;
  if (setPrototypeOf$1) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global$8[ARRAY];
      if (TypedArrayConstructor && hasOwn$3(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray$1[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn$2(TypedArray$1, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && TypedArray$1[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$8[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn$2(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global$8[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global$8[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState$1(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !isCallable$1(TypedArray$1) || TypedArray$1 === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray$1 = function TypedArray() {
    throw new TypeError$3('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME in TypedArrayConstructorsList) {
    if (global$8[NAME]) setPrototypeOf$1(global$8[NAME], TypedArray$1);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !TypedArrayPrototype$1 || TypedArrayPrototype$1 === ObjectPrototype) {
  TypedArrayPrototype$1 = TypedArray$1.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$2) for (NAME in TypedArrayConstructorsList) {
    if (global$8[NAME]) setPrototypeOf$1(global$8[NAME].prototype, TypedArrayPrototype$1);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS$2 && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$1) {
  setPrototypeOf$1(Uint8ClampedArrayPrototype, TypedArrayPrototype$1);
}

if (DESCRIPTORS$5 && !hasOwn$3(TypedArrayPrototype$1, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor$3(TypedArrayPrototype$1, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject$4(this) ? this[TYPED_ARRAY_TAG$1] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global$8[NAME]) {
    createNonEnumerableProperty$1(global$8[NAME], TYPED_ARRAY_TAG$1, NAME);
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$2,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG$1,
  aTypedArray: aTypedArray$4,
  aTypedArrayConstructor: aTypedArrayConstructor$1,
  exportTypedArrayMethod: exportTypedArrayMethod$4,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray$1,
  TypedArray: TypedArray$1,
  TypedArrayPrototype: TypedArrayPrototype$1
};

/* eslint-disable no-new -- required for testing */
var global$7 = global$w;
var fails$9 = fails$x;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$2;
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$2 = global$7.ArrayBuffer;
var Int8Array$3 = global$7.Int8Array;

var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails$9(function () {
  Int8Array$3(1);
}) || !fails$9(function () {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails$9(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$3(new ArrayBuffer$2(2), 1, undefined).length !== 1;
});

var isObject$3 = isObject$g;

var floor$3 = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
var isIntegralNumber$1 = Number.isInteger || function isInteger(it) {
  return !isObject$3(it) && isFinite(it) && floor$3(it) === it;
};

var toIntegerOrInfinity = toIntegerOrInfinity$9;

var $RangeError$2 = RangeError;

var toPositiveInteger$1 = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw new $RangeError$2("The argument can't be less than 0");
  return result;
};

var toPositiveInteger = toPositiveInteger$1;

var $RangeError$1 = RangeError;

var toOffset$2 = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw new $RangeError$1('Wrong offset');
  return offset;
};

var round = Math.round;

var toUint8Clamped$1 = function (it) {
  var value = round(it);
  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
};

var classof$4 = classof$c;

var isBigIntArray$1 = function (it) {
  var klass = classof$4(it);
  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};

var toPrimitive = toPrimitive$2;

var $TypeError$1 = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
var toBigInt$2 = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw new $TypeError$1("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

var bind$4 = functionBindContext;
var call$7 = functionCall;
var aConstructor = aConstructor$2;
var toObject$4 = toObject$9;
var lengthOfArrayLike$5 = lengthOfArrayLike$9;
var getIterator$2 = getIterator$4;
var getIteratorMethod$2 = getIteratorMethod$5;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$3;
var isBigIntArray = isBigIntArray$1;
var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
var toBigInt$1 = toBigInt$2;

var typedArrayFrom$1 = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject$4(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod$2(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod$1(iteratorMethod)) {
    iterator = getIterator$2(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call$7(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind$4(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike$5(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt$1(value) : +value;
  }
  return result;
};

var classof$3 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$2 = Array.isArray || function isArray(argument) {
  return classof$3(argument) === 'Array';
};

var isArray$1 = isArray$2;
var isConstructor$1 = isConstructor$3;
var isObject$2 = isObject$g;
var wellKnownSymbol$2 = wellKnownSymbol$m;

var SPECIES = wellKnownSymbol$2('species');
var $Array$1 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$1(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$1(C) && (C === $Array$1 || isArray$1(C.prototype))) C = undefined;
    else if (isObject$2(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$1 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind$3 = functionBindContext;
var uncurryThis$9 = functionUncurryThis;
var IndexedObject$1 = indexedObject;
var toObject$3 = toObject$9;
var lengthOfArrayLike$4 = lengthOfArrayLike$9;
var arraySpeciesCreate = arraySpeciesCreate$1;

var push$5 = uncurryThis$9([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$3($this);
    var self = IndexedObject$1(O);
    var length = lengthOfArrayLike$4(self);
    var boundFunction = bind$3(callbackfn, that);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$5(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$5(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};

var lengthOfArrayLike$3 = lengthOfArrayLike$9;

var arrayFromConstructorAndList$1 = function (Constructor, list, $length) {
  var index = 0;
  var length = arguments.length > 2 ? $length : lengthOfArrayLike$3(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var $$4 = _export;
var global$6 = global$w;
var call$6 = functionCall;
var DESCRIPTORS$4 = descriptors;
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = typedArrayConstructorsRequireWrappers;
var ArrayBufferViewCore$4 = arrayBufferViewCore;
var ArrayBufferModule = arrayBuffer;
var anInstance$2 = anInstance$5;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;
var createNonEnumerableProperty = createNonEnumerableProperty$8;
var isIntegralNumber = isIntegralNumber$1;
var toLength$1 = toLength$a;
var toIndex = toIndex$2;
var toOffset$1 = toOffset$2;
var toUint8Clamped = toUint8Clamped$1;
var toPropertyKey$1 = toPropertyKey$4;
var hasOwn$2 = hasOwnProperty_1;
var classof$2 = classof$c;
var isObject$1 = isObject$g;
var isSymbol = isSymbol$3;
var create$1 = objectCreate;
var isPrototypeOf = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var typedArrayFrom = typedArrayFrom$1;
var forEach = arrayIteration.forEach;
var setSpecies = setSpecies$2;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$7;
var definePropertyModule$1 = objectDefineProperty;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var arrayFromConstructorAndList = arrayFromConstructorAndList$1;
var InternalStateModule$3 = internalState;
var inheritIfRequired = inheritIfRequired$2;

var getInternalState$1 = InternalStateModule$3.get;
var setInternalState$3 = InternalStateModule$3.set;
var enforceInternalState = InternalStateModule$3.enforce;
var nativeDefineProperty = definePropertyModule$1.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var RangeError$2 = global$6.RangeError;
var ArrayBuffer$1 = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer$1.prototype;
var DataView$1 = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore$4.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore$4.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore$4.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore$4.TypedArrayPrototype;
var isTypedArray = ArrayBufferViewCore$4.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var addGetter = function (it, key) {
  defineBuiltInAccessor$2(it, key, {
    configurable: true,
    get: function () {
      return getInternalState$1(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof$2(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey$1(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor$2(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey$1(key);
  if (isTypedArrayIndex(target, key)
    && isObject$1(descriptor)
    && hasOwn$2(descriptor, 'value')
    && !hasOwn$2(descriptor, 'get')
    && !hasOwn$2(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn$2(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn$2(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS$4) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule$1.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $$4({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  typedArrayConstructor.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global$6[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState$1(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState$1(that);
      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance$2(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject$1(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer$1(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset$1(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw new RangeError$2(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw new RangeError$2(WRONG_LENGTH);
          } else {
            byteLength = toLength$1($length) * BYTES;
            if (byteLength + byteOffset > $len) throw new RangeError$2(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return arrayFromConstructorAndList(TypedArrayConstructor, data);
        } else {
          return call$6(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState$3(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView$1(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create$1(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance$2(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject$1(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset$1(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset$1(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
          return call$6(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $$4({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else typedArrayConstructor.exports = function () { /* empty */ };

var createTypedArrayConstructor = typedArrayConstructor.exports;

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var ArrayBufferViewCore$3 = arrayBufferViewCore;
var $fill = arrayFill$1;
var toBigInt = toBigInt$2;
var classof$1 = classof$c;
var call$5 = functionCall;
var uncurryThis$8 = functionUncurryThis;
var fails$8 = fails$x;

var aTypedArray$3 = ArrayBufferViewCore$3.aTypedArray;
var exportTypedArrayMethod$3 = ArrayBufferViewCore$3.exportTypedArrayMethod;
var slice = uncurryThis$8(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails$8(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod$3('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray$3(this);
  var actualValue = slice(classof$1(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call$5($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

var global$5 = global$w;
var call$4 = functionCall;
var ArrayBufferViewCore$2 = arrayBufferViewCore;
var lengthOfArrayLike$2 = lengthOfArrayLike$9;
var toOffset = toOffset$2;
var toIndexedObject = toObject$9;
var fails$7 = fails$x;

var RangeError$1 = global$5.RangeError;
var Int8Array$2 = global$5.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$2 = ArrayBufferViewCore$2.aTypedArray;
var exportTypedArrayMethod$2 = ArrayBufferViewCore$2.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails$7(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call$4($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore$2.NATIVE_ARRAY_BUFFER_VIEWS && fails$7(function () {
  var array = new Int8Array$2(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$2('set', function set(arrayLike /* , offset */) {
  aTypedArray$2(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call$4($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike$2(src);
  var index = 0;
  if (len + offset > length) throw new RangeError$1('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

var arraySlice$2 = arraySlice$5;

var floor$2 = Math.floor;

var sort = function (array, comparefn) {
  var length = array.length;

  if (length < 8) {
    // insertion sort
    var i = 1;
    var element, j;

    while (i < length) {
      j = i;
      element = array[i];
      while (j && comparefn(array[j - 1], element) > 0) {
        array[j] = array[--j];
      }
      if (j !== i++) array[j] = element;
    }
  } else {
    // merge sort
    var middle = floor$2(length / 2);
    var left = sort(arraySlice$2(array, 0, middle), comparefn);
    var right = sort(arraySlice$2(array, middle), comparefn);
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;

    while (lindex < llength || rindex < rlength) {
      array[lindex + rindex] = (lindex < llength && rindex < rlength)
        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
        : lindex < llength ? left[lindex++] : right[rindex++];
    }
  }

  return array;
};

var arraySort$1 = sort;

var userAgent$1 = engineUserAgent;

var firefox = userAgent$1.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var UA = engineUserAgent;

var engineIsIeOrEdge = /MSIE|Trident/.test(UA);

var userAgent = engineUserAgent;

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var global$4 = global$w;
var uncurryThis$7 = functionUncurryThisClause;
var fails$6 = fails$x;
var aCallable$1 = aCallable$a;
var internalSort$1 = arraySort$1;
var ArrayBufferViewCore$1 = arrayBufferViewCore;
var FF$1 = engineFfVersion;
var IE_OR_EDGE$1 = engineIsIeOrEdge;
var V8$1 = engineV8Version;
var WEBKIT$1 = engineWebkitVersion;

var aTypedArray$1 = ArrayBufferViewCore$1.aTypedArray;
var exportTypedArrayMethod$1 = ArrayBufferViewCore$1.exportTypedArrayMethod;
var Uint16Array = global$4.Uint16Array;
var nativeSort$1 = Uint16Array && uncurryThis$7(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort$1 && !(fails$6(function () {
  nativeSort$1(new Uint16Array(2), null);
}) && fails$6(function () {
  nativeSort$1(new Uint16Array(2), {});
}));

var STABLE_SORT$1 = !!nativeSort$1 && !fails$6(function () {
  // feature detection can be too slow, so check engines versions
  if (V8$1) return V8$1 < 74;
  if (FF$1) return FF$1 < 67;
  if (IE_OR_EDGE$1) return true;
  if (WEBKIT$1) return WEBKIT$1 < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort$1(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare$1 = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod$1('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable$1(comparefn);
  if (STABLE_SORT$1) return nativeSort$1(this, comparefn);

  return internalSort$1(aTypedArray$1(this), getSortCompare$1(comparefn));
}, !STABLE_SORT$1 || ACCEPT_INCORRECT_ARGUMENTS);

var global$3 = global$w;
var apply = functionApply;
var ArrayBufferViewCore = arrayBufferViewCore;
var fails$5 = fails$x;
var arraySlice$1 = arraySlice$5;

var Int8Array$1 = global$3.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails$5(function () {
  $toLocaleString.call(new Int8Array$1(1));
});

var FORCED$1 = fails$5(function () {
  return [1, 2].toLocaleString() !== new Int8Array$1([1, 2]).toLocaleString();
}) || !fails$5(function () {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice$1(aTypedArray(this)) : aTypedArray(this),
    arraySlice$1(arguments)
  );
}, FORCED$1);

var charAt$2 = stringMultibyte.charAt;
var toString$2 = toString$d;
var InternalStateModule$2 = internalState;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState = InternalStateModule$2.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: toString$2(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject$1(undefined, true);
  point = charAt$2(string, index);
  state.index += point.length;
  return createIterResultObject$1(point, false);
});

var fails$4 = fails$x;
var wellKnownSymbol$1 = wellKnownSymbol$m;
var DESCRIPTORS$3 = descriptors;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$1('iterator');

var urlConstructorDetection = !fails$4(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (IS_PURE || !DESCRIPTORS$3))
    || !params.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var DESCRIPTORS$2 = descriptors;
var uncurryThis$6 = functionUncurryThis;
var call$3 = functionCall;
var fails$3 = fails$x;
var objectKeys = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$2 = toObject$9;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis$6([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$3(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$2 && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$2(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$2 || call$3(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var anObject$2 = anObject$j;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$2(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var toPropertyKey = toPropertyKey$4;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;

var createProperty$1 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor$1(0, value));
  else object[propertyKey] = value;
};

var bind$2 = functionBindContext;
var call$2 = functionCall;
var toObject$1 = toObject$9;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$3;
var isConstructor = isConstructor$3;
var lengthOfArrayLike$1 = lengthOfArrayLike$9;
var createProperty = createProperty$1;
var getIterator$1 = getIterator$4;
var getIteratorMethod$1 = getIteratorMethod$5;

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$2(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$2(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$1(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis$5 = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec$1 = uncurryThis$5(regexSeparators.exec);
var floor$1 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$5(''.charCodeAt);
var join$2 = uncurryThis$5([].join);
var push$4 = uncurryThis$5([].push);
var replace$2 = uncurryThis$5(''.replace);
var split$2 = uncurryThis$5(''.split);
var toLowerCase$1 = uncurryThis$5(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
        push$4(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$4(output, value);
        counter--;
      }
    } else {
      push$4(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$1(delta / damp) : delta >> 1;
  delta += floor$1(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$1(delta / baseMinusTMin);
    k += base;
  }
  return floor$1(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$4(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$4(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$1((maxInt - delta) / handledCPCountPlusOne)) {
      throw new $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw new $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue === n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$4(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$1(qMinusT / baseMinusT);
          k += base;
        }

        push$4(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$2(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$2(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$4(encoded, exec$1(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$2(encoded, '.');
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$3 = _export;
var global$2 = global$w;
var safeGetBuiltIn = safeGetBuiltIn$2;
var call$1 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var DESCRIPTORS$1 = descriptors;
var USE_NATIVE_URL$1 = urlConstructorDetection;
var defineBuiltIn$1 = defineBuiltIn$b;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$7;
var defineBuiltIns = defineBuiltIns$2;
var setToStringTag$1 = setToStringTag$7;
var createIteratorConstructor = iteratorCreateConstructor;
var InternalStateModule$1 = internalState;
var anInstance$1 = anInstance$5;
var isCallable = isCallable$p;
var hasOwn$1 = hasOwnProperty_1;
var bind$1 = functionBindContext;
var classof = classof$c;
var anObject$1 = anObject$j;
var isObject = isObject$g;
var $toString$1 = toString$d;
var create = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$6;
var getIterator = getIterator$4;
var getIteratorMethod = getIteratorMethod$5;
var createIterResultObject = createIterResultObject$3;
var validateArgumentsLength$1 = validateArgumentsLength$3;
var wellKnownSymbol = wellKnownSymbol$m;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp$1 = global$2.RegExp;
var TypeError$2 = global$2.TypeError;
var decodeURIComponent = global$2.decodeURIComponent;
var encodeURIComponent$1 = global$2.encodeURIComponent;
var charAt$1 = uncurryThis$4(''.charAt);
var join$1 = uncurryThis$4([].join);
var push$3 = uncurryThis$4([].push);
var replace$1 = uncurryThis$4(''.replace);
var shift$1 = uncurryThis$4([].shift);
var splice = uncurryThis$4([].splice);
var split$1 = uncurryThis$4(''.split);
var stringSlice$2 = uncurryThis$4(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$1(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$1(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$1(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$1(init, 0) === '?' ? stringSlice$2(init, 1) : init : $toString$1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$1(next, iterator)).done) {
        entryIterator = getIterator(anObject$1(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$1(entryNext, entryIterator)).done ||
          (second = call$1(entryNext, entryIterator)).done ||
          !call$1(entryNext, entryIterator).done
        ) throw new TypeError$2('Expected sequence with length 2');
        push$3(entries, { key: $toString$1(first.value), value: $toString$1(second.value) });
      }
    } else for (var key in object) if (hasOwn$1(object, key)) {
      push$3(entries, { key: key, value: $toString$1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$3(entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$1(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$3(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$1(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$1(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS$1) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$1(arguments.length, 2);
    push$3(state.entries, { key: $toString$1(name), value: $toString$1(value) });
    if (!DESCRIPTORS$1) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength$1(arguments.length, 1);
    var entries = state.entries;
    var key = $toString$1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString$1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!DESCRIPTORS$1) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$3(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength$1(arguments.length, 1);
    var key = $toString$1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : $toString$1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength$1(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = $toString$1(name);
    var val = $toString$1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$3(entries, { key: key, value: val });
    if (!DESCRIPTORS$1) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$1(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$1(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$1(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS$1) defineBuiltInAccessor$1(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$3({ global: true, constructor: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable(Headers)) {
  var headersHas = uncurryThis$4(HeadersPrototype.has);
  var headersSet = uncurryThis$4(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString$1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $$3({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$1(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$3({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$2 = _export;
var DESCRIPTORS = descriptors;
var USE_NATIVE_URL = urlConstructorDetection;
var global$1 = global$w;
var bind = functionBindContext;
var uncurryThis$3 = functionUncurryThis;
var defineBuiltIn = defineBuiltIn$b;
var defineBuiltInAccessor = defineBuiltInAccessor$7;
var anInstance = anInstance$5;
var hasOwn = hasOwnProperty_1;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice = arraySlice$5;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString = toString$d;
var setToStringTag = setToStringTag$7;
var validateArgumentsLength = validateArgumentsLength$3;
var URLSearchParamsModule = web_urlSearchParams_constructor;
var InternalStateModule = internalState;

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global$1.URL;
var TypeError$1 = global$1.TypeError;
var parseInt = global$1.parseInt;
var floor = Math.floor;
var pow = Math.pow;
var charAt = uncurryThis$3(''.charAt);
var exec = uncurryThis$3(/./.exec);
var join = uncurryThis$3([].join);
var numberToString = uncurryThis$3(1.0.toString);
var pop = uncurryThis$3([].pop);
var push$2 = uncurryThis$3([].push);
var replace = uncurryThis$3(''.replace);
var shift = uncurryThis$3([].shift);
var split = uncurryThis$3(''.split);
var stringSlice$1 = uncurryThis$3(''.slice);
var toLowerCase = uncurryThis$3(''.toLowerCase);
var unshift = uncurryThis$3([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] === '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part === '') return input;
    radix = 10;
    if (part.length > 1 && charAt(part, 0) === '0') {
      radix = exec(HEX_START, part) ? 16 : 8;
      part = stringSlice$1(part, radix === 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push$2(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index === partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt(input, pointer);
  };

  if (chr() === ':') {
    if (charAt(input, 1) !== ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex === 8) return;
    if (chr() === ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() === '.') {
      if (length === 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() === '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec(DIGIT, chr())) return;
        while (exec(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece === 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
      }
      if (numbersSeen !== 4) return;
      break;
    } else if (chr() === ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex !== 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex !== 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor(host / 256);
    } return join(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length === 2 && exec(ALPHA, charAt(string, 0))
    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$1(string, 0, 2)) && (
    string.length === 2 ||
    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw new TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw new TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
    }

    input = replace(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
            buffer += toLowerCase(chr);
          } else if (chr === ':') {
            if (stateOverride && (
              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme === 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme === 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] === '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$2(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr === '#') {
            url.scheme = base.scheme;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme === 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr === '/' && codePoints[pointer + 1] === '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr === '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr === EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr === '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr === '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr !== '/' && chr !== '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr === '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint === ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer === '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme === 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr === ':' && !seenBracket) {
            if (buffer === '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride === HOSTNAME) return;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer === '') return INVALID_HOST;
            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr === '[') seenBracket = true;
            else if (chr === ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
            (chr === '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer !== '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr === '/' || chr === '\\') state = FILE_SLASH;
          else if (base && base.scheme === 'file') {
            switch (chr) {
              case EOF:
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                break;
              case '?':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = '';
                state = QUERY;
                break;
              case '#':
                url.host = base.host;
                url.path = arraySlice(base.path);
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
                break;
              default:
                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
                  url.host = base.host;
                  url.path = arraySlice(base.path);
                  url.shortenPath();
                }
                state = PATH;
                continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr === '/' || chr === '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$2(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer === '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host === 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr !== '/' && chr !== '\\') continue;
          } else if (!stateOverride && chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            state = PATH;
            if (chr !== '/') continue;
          } break;

        case PATH:
          if (
            chr === EOF || chr === '/' ||
            (chr === '\\' && url.isSpecial()) ||
            (!stateOverride && (chr === '?' || chr === '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$2(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
                push$2(url.path, '');
              }
            } else {
              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$2(url.path, buffer);
            }
            buffer = '';
            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr === '?') {
              url.query = '';
              state = QUERY;
            } else if (chr === '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr === '?') {
            url.query = '';
            state = QUERY;
          } else if (chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr === '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr !== EOF) {
            if (chr === "'" && url.isSpecial()) url.query += '%27';
            else if (chr === '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt(input, 0) === '[') {
      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$1(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username !== '' || this.password !== '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme === 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw new TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme === 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme === 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString(port);
    if (port === '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString(search);
    if (search === '') {
      this.query = null;
    } else {
      if (charAt(search, 0) === '?') search = stringSlice$1(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString(hash);
    if (hash === '') {
      this.fragment = null;
      return;
    }
    if (charAt(hash, 0) === '#') hash = stringSlice$1(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$$2({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class AthenaeumConstants {}
AthenaeumConstants.badRequestStatusCode = 400;
AthenaeumConstants.unauthorizedStatusCode = 401;
AthenaeumConstants.forbiddenStatusCode = 403;
AthenaeumConstants.notFoundStatusCode = 404;
AthenaeumConstants.internalServerErrorStatusCode = 500;
AthenaeumConstants.okStatusCode = 200;
/**
 * 768px (bootstrap: $break-md)
 */
AthenaeumConstants.desktopMinWidth = 768;
AthenaeumConstants.newLineRegex = /\r\n|\\r\\n|\n\r|\n|\\n|\r|<br>|<br\/>/g;
AthenaeumConstants.markTagRegex = /<\s*mark[^>]*>(.*?)<\s*\/\s*mark>/ig;
AthenaeumConstants.smallTagRegex = /<\s*small[^>]*>(.*?)<\s*\/\s*small>/ig;
AthenaeumConstants.boldTagRegex = /<\s*b[^>]*>(.*?)<\s*\/\s*b>/ig;
AthenaeumConstants.italicTagRegex = /<\s*i[^>]*>(.*?)<\s*\/\s*i>/ig;
AthenaeumConstants.dateRegex = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(:([0-5][0-9]))?(Z)?$/;
AthenaeumConstants.zeroTimeRegex = /T00:00:00((.?0+)?)$/;
AthenaeumConstants.defaultGuid = "00000000-0000-0000-0000-000000000000";
AthenaeumConstants.apiError = "__API__";

class HashCodeUtility {
  static inc(hash, value) {
    return (hash << 5) - hash + value & 0xFFFFFFFF;
  }
  static object(object) {
    if (object instanceof Date) {
      return this.getDateHashCode(object);
    }
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    let hash = 0;
    for (const property in object) {
      if (hasOwnProperty.call(object, property)) {
        //hash += HashCodeUtility.hash(property + HashCodeUtility.getHashCode(object[property]));
        hash = this.inc(hash, this.getStringHashCode(property));
        hash = this.inc(hash, this.getHashCode(object[property]));
      }
    }
    return hash;
  }
  static getStringHashCode(value) {
    // return (value)
    //     ? value.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0)
    //     : 0;
    const length = value.length;
    let hash = 0;
    for (let i = 0; i < length; i++) {
      //hash = (((hash << 5) - hash) + string.charCodeAt(i)) & 0xFFFFFFFF;
      hash = this.inc(hash, value.charCodeAt(i));
    }
    return hash;
  }
  static getNumberHashCode(value) {
    return this.getStringHashCode(value.toString());
  }
  static getBooleanHashCode(value) {
    //return this.getStringHashCode(value.toString());
    return value ? 3569038 : 97196323;
  }
  static getDateHashCode(value) {
    return this.getNumberHashCode(value.valueOf());
  }
  /**
   * Serves as the default hash function.
   * @returns Number - A hash code for the current object.
   */
  static getHashCode(value) {
    if (value != null) {
      switch (typeof value) {
        case "string":
          return this.getStringHashCode(value);
        case "number":
          return this.getNumberHashCode(value);
        case "boolean":
          return this.getBooleanHashCode(value);
        case "object":
          return this.object(value);
      }
    }
    return 0;
  }
  static isEqual(x, y) {
    return this.getHashCode(x) === this.getHashCode(y);
  }
}

class DateUtility {
  static compare(x, y, inverse = false) {
    x = typeof x === "string" ? new Date(x) : x;
    y = typeof y === "string" ? new Date(y) : y;
    const xValue = x.valueOf();
    const yValue = y.valueOf();
    if (xValue < yValue) {
      return inverse ? 1 : -1;
    }
    if (xValue > yValue) {
      return inverse ? -1 : 1;
    }
    return 0;
  }
  static equals(x, y) {
    x = typeof x === "string" ? new Date(x) : x;
    y = typeof y === "string" ? new Date(y) : y;
    const xValue = x.valueOf();
    const yValue = y.valueOf();
    return xValue === yValue;
  }
}

const DateExtensions = function DateExtensions() {
  if (Date.prototype.format == null) {
    Date.prototype.format = function (format) {
      return Utility$1.formatValue(this, format);
    };
  }
  if (Date.prototype.date == null) {
    Date.prototype.date = function () {
      return Utility$1.getDateWithoutTime(this);
    };
  }
  if (Date.prototype.addDays == null) {
    Date.prototype.addDays = function (value) {
      return Utility$1.addDays(this, value);
    };
  }
  if (Date.prototype.addMonths == null) {
    Date.prototype.addMonths = function (value) {
      return Utility$1.addMonths(this, value);
    };
  }
  if (Date.prototype.addYears == null) {
    Date.prototype.addYears = function (value) {
      return Utility$1.addYears(this, value);
    };
  }
  if (Date.prototype.addMilliseconds == null) {
    Date.prototype.addMilliseconds = function (value) {
      return Utility$1.addMilliseconds(this, value);
    };
  }
  if (Date.prototype.toUniversalTime == null) {
    Date.prototype.toUniversalTime = function () {
      return Utility$1.toUtc(this);
    };
  }
  if (Date.prototype.toLocalTime == null) {
    Date.prototype.toLocalTime = function () {
      return Utility$1.toLocal(this);
    };
  }
  if (Date.prototype.utcValueOf == null) {
    Date.prototype.utcValueOf = function () {
      return Utility$1.utcValueOf(this);
    };
  }
  if (Date.prototype.getHashCode == null) {
    Date.prototype.getHashCode = function () {
      return HashCodeUtility.getDateHashCode(this);
    };
  }
  if (Date.prototype.inFuture == null) {
    Date.prototype.inFuture = function () {
      return Utility$1.inFuture(this);
    };
  }
  if (Date.prototype.inPast == null) {
    Date.prototype.inPast = function () {
      return Utility$1.inPast(this);
    };
  }
  if (Date.prototype.isSunday == null) {
    Date.prototype.isSunday = function () {
      return Utility$1.isSunday(this);
    };
  }
  if (Date.prototype.isToday == null) {
    Date.prototype.isToday = function () {
      return Utility$1.isToday(this);
    };
  }
  if (Date.prototype.getFirstDayOfWeek == null) {
    Date.prototype.getFirstDayOfWeek = function () {
      return Utility$1.getFirstDayOfWeek(this);
    };
  }
  if (Date.prototype.getLastDayOfWeek == null) {
    Date.prototype.getLastDayOfWeek = function () {
      return Utility$1.getLastDayOfWeek(this);
    };
  }
  if (Date.prototype.getFirstDayOfMonth == null) {
    Date.prototype.getFirstDayOfMonth = function () {
      return Utility$1.getFirstDayOfMonth(this);
    };
  }
  if (Date.prototype.getLastDayOfMonth == null) {
    Date.prototype.getLastDayOfMonth = function () {
      return Utility$1.getLastDayOfMonth(this);
    };
  }
  if (Date.prototype.getISOWeekNumber == null) {
    Date.prototype.getISOWeekNumber = function () {
      return Utility$1.getISOWeekNumber(this);
    };
  }
  if (Date.prototype.inInterval == null) {
    Date.prototype.inInterval = function (from, to) {
      return Utility$1.inInterval(this, from, to);
    };
  }
  if (Date.prototype.toISODateString == null) {
    Date.prototype.toISODateString = function () {
      return Utility$1.toISODateString(this);
    };
  }
  if (Date.prototype.toLongISOString == null) {
    Date.prototype.toLongISOString = function () {
      return Utility$1.toLongISOString(this);
    };
  }
  if (Date.prototype.getDaysInMonth == null) {
    Date.prototype.getDaysInMonth = function () {
      return Utility$1.getDaysInMonth(this);
    };
  }
  if (Date.prototype.compareTo == null) {
    Date.prototype.compareTo = function (value, inverse = false) {
      return DateUtility.compare(this, value, inverse);
    };
  }
  if (Date.prototype.equals == null) {
    Date.prototype.equals = function (value) {
      return DateUtility.equals(this, value);
    };
  }
};
DateExtensions();

class StringUtility {
  static compare(x, y, inverse = false) {
    if (x < y) {
      return inverse ? 1 : -1;
    }
    if (x > y) {
      return inverse ? -1 : 1;
    }
    return 0;
  }
  static toPascalCase(value) {
    return _.upperFirst(_.camelCase(value));
  }
}

const StringExtensions = function StringExtensions() {
  if (String.prototype.format == null) {
    String.prototype.format = function (...args) {
      return Utility$1.format(this, ...args);
    };
  }
  if (String.prototype.getHashCode == null) {
    String.prototype.getHashCode = function () {
      return HashCodeUtility.getStringHashCode(this);
    };
  }
  if (String.prototype.toPascalCase == null) {
    String.prototype.toPascalCase = function () {
      return StringUtility.toPascalCase(this);
    };
  }
};
StringExtensions();

var tryToString = tryToString$6;

var $TypeError = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var fails$2 = fails$x;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$2(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $$1 = _export;
var uncurryThis$2 = functionUncurryThis;
var aCallable = aCallable$a;
var toObject = toObject$9;
var lengthOfArrayLike = lengthOfArrayLike$9;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var toString$1 = toString$d;
var fails$1 = fails$x;
var internalSort = arraySort$1;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;

var test$1 = [];
var nativeSort = uncurryThis$2(test$1.sort);
var push$1 = uncurryThis$2(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails$1(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails$1(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails$1(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString$1(x) > toString$1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$$1({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$1(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});

var SortDirection;
(function (SortDirection) {
  SortDirection[SortDirection["Asc"] = 0] = "Asc";
  SortDirection[SortDirection["Desc"] = 1] = "Desc";
})(SortDirection || (SortDirection = {}));
class ArrayUtility {
  static sortByProperty(propertyName, sortDirection = SortDirection.Asc) {
    const direction = sortDirection == SortDirection.Desc ? -1 : 1;
    return (firstItem, secondItem) => {
      const x = firstItem[propertyName];
      const y = secondItem[propertyName];
      const result = x < y ? -1 : x > y ? 1 : 0;
      return result * direction;
    };
  }
  static sort(first, second, sortingType = SortDirection.Asc) {
    const direction = sortingType == SortDirection.Desc ? -1 : 1;
    const result = first < second ? -1 : first > second ? 1 : 0;
    return result * direction;
  }
  static order(source, keySelector1, keySelector2, keySelector3, keySelector4, keySelector5) {
    const compare = (keySelector, x, y) => {
      const xKey = keySelector(x);
      const yKey = keySelector(y);
      if (Utility$1.isDateType(xKey)) {
        return DateUtility.compare(xKey, yKey);
      }
      return xKey > yKey ? 1 : xKey < yKey ? -1 : 0;
    };
    const comparator = (x, y) => {
      let value = compare(keySelector1, x, y);
      if (value === 0 && keySelector2) {
        value = compare(keySelector2, x, y);
        if (value === 0 && keySelector3) {
          value = compare(keySelector3, x, y);
          if (value === 0 && keySelector4) {
            value = compare(keySelector4, x, y);
            if (value === 0 && keySelector5) {
              value = compare(keySelector5, x, y);
            }
          }
        }
      }
      return value;
    };
    source.sort(comparator);
  }
  static chunk(givenArray, chunkSize) {
    const result = [];
    const givenArrayCopy = [...givenArray];
    while (givenArrayCopy.length) {
      result.push(givenArrayCopy.splice(0, chunkSize));
    }
    return result;
  }
  static take(items, count) {
    if (count < 0) {
      count = 0;
    }
    let length = items.length;
    if (count >= 0 && count < length) {
      length = count;
    }
    const result = new Array(length);
    for (let i = 0; i < length; i++) {
      result[i] = items[i];
    }
    return result;
  }
  static skip(items, count) {
    if (count < 0) {
      count = 0;
    }
    const length = items.length;
    const firstIndex = count < length ? count : length;
    const newLength = length - firstIndex;
    const result = new Array(newLength);
    for (let dest = 0, source = firstIndex; dest < newLength; dest++, source++) {
      result[dest] = items[source];
    }
    return result;
  }
  static firstOrDefault(items, callback, defaultValue) {
    const length = items.length;
    if (callback) {
      for (let i = 0; i < length; i++) {
        const item = items[i];
        if (callback(item)) {
          return item;
        }
      }
    } else if (length > 0) {
      return items[0];
    }
    return defaultValue !== null && defaultValue !== void 0 ? defaultValue : null;
  }
}

const ArrayExtensions = function ArrayExtensions() {
  if (Array.prototype.where == null) {
    Array.prototype.where = function (predicate) {
      return Utility$1.where(this, predicate);
    };
  }
  if (Array.prototype.whereAsync == null) {
    Array.prototype.whereAsync = function (callback) {
      return Utility$1.whereAsync(this, callback);
    };
  }
  if (Array.prototype.take == null) {
    Array.prototype.take = function (count) {
      return ArrayUtility.take(this, count);
    };
  }
  if (Array.prototype.skip == null) {
    Array.prototype.skip = function (count) {
      return ArrayUtility.skip(this, count);
    };
  }
  if (Array.prototype.selectMany == null) {
    Array.prototype.selectMany = function (collectionSelector) {
      return Utility$1.selectMany(this, collectionSelector);
    };
  }
  if (Array.prototype.groupBy == null) {
    Array.prototype.groupBy = function (callback) {
      return Utility$1.groupBy(this, callback);
    };
  }
  if (Array.prototype.remove == null) {
    Array.prototype.remove = function (item) {
      Utility$1.remove(this, item);
    };
  }
  if (Array.prototype.removeAt == null) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Array.prototype.removeAt = function (index) {
      Utility$1.removeAt(this, index);
    };
  }
  if (Array.prototype.max == null) {
    Array.prototype.max = function (callback = null) {
      return Utility$1.max(this, callback);
    };
  }
  if (Array.prototype.maxValue == null) {
    Array.prototype.maxValue = function (callback) {
      return Utility$1.maxValue(this, callback);
    };
  }
  if (Array.prototype.min == null) {
    Array.prototype.min = function (callback = null) {
      return Utility$1.min(this, callback);
    };
  }
  if (Array.prototype.minValue == null) {
    Array.prototype.minValue = function (callback) {
      return Utility$1.minValue(this, callback);
    };
  }
  if (Array.prototype.sum == null) {
    Array.prototype.sum = function (callback) {
      return Utility$1.sum(this, callback);
    };
  }
  if (Array.prototype.count == null) {
    Array.prototype.count = function (callback) {
      return Utility$1.count(this, callback);
    };
  }
  if (Array.prototype.chunk == null) {
    Array.prototype.chunk = function (chunkSize) {
      return ArrayUtility.chunk(this, chunkSize);
    };
  }
  if (Array.prototype.distinct == null) {
    Array.prototype.distinct = function (callback = null) {
      return Utility$1.distinct(this, callback);
    };
  }
  if (Array.prototype.order == null) {
    Array.prototype.order = function (keySelector1, keySelector2, keySelector3, keySelector4, keySelector5) {
      ArrayUtility.order(this, keySelector1, keySelector2, keySelector3, keySelector4, keySelector5);
    };
  }
  if (Array.prototype.toPagedList == null) {
    Array.prototype.toPagedList = function (pageNumber, pageSize) {
      return Utility$1.toPagedList(this, pageNumber, pageSize);
    };
  }
  if (Array.prototype.forEachAsync == null) {
    Array.prototype.forEachAsync = function (callback) {
      return Utility$1.forEachAsync(this, callback);
    };
  }
  if (Array.prototype.firstOrDefault == null) {
    Array.prototype.firstOrDefault = function (callback, defaultValue) {
      return ArrayUtility.firstOrDefault(this, callback, defaultValue);
    };
  }
};
ArrayExtensions();

const NumberExtensions = function NumberExtensions() {
  if (Number.prototype.format == null) {
    Number.prototype.format = function (format) {
      return Utility$1.formatValue(this, format);
    };
  }
  if (Number.prototype.getHashCode == null) {
    Number.prototype.getHashCode = function () {
      return HashCodeUtility.getNumberHashCode(this);
    };
  }
};
NumberExtensions();

/**
 * Implementation of {@link ITypeResolver}.
 */
class TypeResolver {
  /**
   * If the object contains an enumerable non-inherited property with a value "true" and a name starting with "isX", where X is any uppercase letter,
   * then return the substring of such propertys name after "is". Otherwise return an empty string.
   *
   * Example: with input {isValue: true} a string "Value" is returned.
   */
  static getIsName(value) {
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    for (const propertyName in value) {
      if (hasOwnProperty.call(value, propertyName)) {
        if (propertyName.length > 2 && propertyName.startsWith("is")) {
          const propertyValue = value[propertyName];
          if (propertyValue === true) {
            const name = propertyName.substr(2);
            const prefix = name[0];
            if (prefix === prefix.toUpperCase()) {
              return name;
            }
          }
        }
      }
    }
    return "";
  }
  /**
   * @return The string "type:" appended with a hash calculated from the objects enumerable non-inherited properties.
   */
  static getObjectTypeHashCode(value) {
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    const properties = [];
    for (const property in value) {
      if (hasOwnProperty.call(value, property)) {
        properties.push(property);
      }
    }
    const hashCode = Utility$1.getHashCode(properties);
    return `type:${hashCode}`;
  }
  /**
   * @return Do the values have equal {@link ServiceType}'s.
   */
  is(value, type) {
    return value != null ? this.resolve(value) === this.resolve(type) : false;
  }
  // ITypeResolver
  resolve(value) {
    switch (typeof value) {
      case "string":
        return "string";
      case "boolean":
        return "boolean";
      case "number":
        return "number";
      case "function":
        return value.name;
      case "object":
        {
          const service = value;
          if (typeof service.getType === "function") {
            return service.getType();
          }
          let name = value.constructor.name;
          if (name !== "Object") {
            return name;
          }
          name = TypeResolver.getIsName(value);
          if (name) {
            return name;
          }
          return TypeResolver.getObjectTypeHashCode(value);
        }
      default:
        return value;
    }
  }
  // IService
  getType() {
    return "ITypeResolver";
  }
}
var TypeResolver$1 = new TypeResolver();

class Singleton {
  constructor() {
    this._data = null;
  }
  getData() {
    if (this._data == null) {
      const container = window;
      this._data = container.__athenaeumSingletonData || (container.__athenaeumSingletonData = new Dictionary());
    }
    return this._data;
  }
  get(name, instance, warning = true) {
    const data = this.getData();
    if (data.containsKey(name)) {
      if (warning) {
        console.warn(`Athenaeum Singleton Warning. Multiple instance of singleton object "${name}" found. Probably several instances of one of the packages are loaded. This will not break the app but it is not recommended to use two major versions.`);
      }
      return data.getValue(name);
    }
    const value = typeof instance === "function" ? instance() : instance;
    data.setValue(name, value);
    return value;
  }
}
var Singleton$1 = new Singleton();

class ServiceProvider {
  constructor() {
    this._services = new Dictionary();
  }
  set(serviceType, service) {
    this._services.setValue(serviceType, service);
  }
  get(serviceType) {
    return this._services.getValue(serviceType);
  }
  /**
   * Resolves service type.
   * @param serviceOrType - A service declaration, service type or service instance.
   * @returns ServiceType - A service type.
   */
  resolveServiceType(serviceOrType) {
    const typeResolver = this.getTypeResolver();
    return typeof serviceOrType === "string" ? serviceOrType : typeResolver.resolve(serviceOrType);
  }
  /**
   * Gets the service object of the specified type.
   * @param serviceOrType - A service declaration, service type or service instance.
   * @param resolve - if True then the service callback will be automatically resolved (invoked); if False, then the function will be returned.
   * @returns IService | object | null - A service object of type serviceType or null if there is no service object of type serviceType.
   */
  getService(serviceOrType, resolve = true) {
    const serviceType = this.resolveServiceType(serviceOrType);
    const service = this.get(serviceType);
    return service != null ? resolve && typeof service === "function" ? service(serviceType) : service : null;
  }
  /**
   * Get service of type serviceType from the IServiceProvider.
   * @param serviceOrType - A service declaration, service type or service instance.
   * @param resolve - if True then the service callback will be automatically resolved (invoked); if False, then the function will be returned.
   * @returns A service object of type serviceType.
   * @exception InvalidOperationException There is no service of type serviceType.
   */
  getRequiredService(serviceOrType, resolve = true) {
    const serviceType = this.resolveServiceType(serviceOrType);
    const service = this.getService(serviceType, resolve);
    if (service == null) throw new Error(`InvalidOperationException. There is no service of type "${serviceType}".`);
    return service;
  }
  /**
   * Adds a singleton service of the type specified in serviceType.
   * @param serviceOrType - A service declaration, service type or service instance.
   * @param service - a service instance if service type is specified in first argument
   */
  addSingleton(serviceOrType, service = null) {
    const serviceType = this.resolveServiceType(serviceOrType);
    service = service != null ? service : serviceOrType;
    this.set(serviceType, service);
  }
  /**
   * @return An {@link ITypeResolver}.
   */
  getTypeResolver() {
    const serviceType = "ITypeResolver";
    const service = this.get(serviceType);
    if (service != null) {
      return service;
    }
    this.set(serviceType, TypeResolver$1);
    return TypeResolver$1;
  }
  /**
   * @return An {@link ILocalizer}, or null if no {@link ILocalizer} service is registered.
   */
  findLocalizer() {
    return this.getService("ILocalizer");
  }
  /**
   * @return An {@link ILocalizer}.
   * @throws No {@link ILocalizer} service is registered.
   */
  getLocalizer() {
    return this.getRequiredService("ILocalizer");
  }
  /**
   * @return An {@link IEnumProvider}, or null if no {@link IEnumProvider} service is registered.
   */
  findEnumProvider() {
    return this.getService("IEnumProvider");
  }
  /**
   * @return An {@link ITransformProvider}, or null if no {@link ITransformProvider} service is registered.
   */
  findTransformProvider() {
    return this.getService("ITransformProvider");
  }
  // IService
  getType() {
    return "ServiceProvider";
  }
}
var ServiceProvider$1 = Singleton$1.get("ServiceProvider", new ServiceProvider());

class Utility {
  static setTimeout(asyncCallback, ms, ...args) {
    const timer = setTimeout(() => asyncCallback(args), ms, args);
    return timer;
  }
  static wait(ms) {
    return new Promise(resolve => this.setTimeout(resolve, ms));
  }
  static get geoEnabled() {
    return this._geoEnabled || (this._geoEnabled = !!navigator.geolocation);
  }
  static getPositionAsync(options = null) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.geoEnabled) {
        options = options || {
          timeout: 1000
        };
        return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, options || undefined)).then(position => {
          return position;
        }).catch(e => {
          const timeout = e.code == 3;
          if (!timeout) {
            this._geoEnabled = false;
          }
          return null;
        });
      } else {
        return new Promise(resolve => resolve(null));
      }
    });
  }
  static getLocationAsync(options = null) {
    return __awaiter(this, void 0, void 0, function* () {
      const position = yield this.getPositionAsync(options);
      if (position) {
        return new GeoCoordinate(position.coords.latitude, position.coords.longitude);
      }
      return null;
    });
  }
  static css(...params) {
    return params ? params.map(param => typeof param === "function" ? param() : param).filter(param => param).join(" ").replace(",", " ").trim() : "";
  }
  /**
   * Format a string.
   * "D" = dd.MM.yyyy
   *
   * @param text String to format.
   * @param params Values used to format the string.
   * @return The input string formatted with the parameters. If the input string is not defined, an empty string.
   */
  static format(text, ...params) {
    let result = text || "";
    if (result && params != null && params.length > 0) {
      params.forEach((param, index) => {
        const prefix = `{${index}`;
        let i = result.indexOf(prefix);
        while (i !== -1) {
          const customFormat = result[i + 2] === ":" && (typeof param === "number" || typeof param === "object" || typeof param === "string");
          if (customFormat) {
            if (param != null && (typeof param === "number" || typeof param === "string" || typeof param === "object" && (param.constructor.name === Date.name || param instanceof TimeSpan || param.isTimeSpan))) {
              const j = result.indexOf("}", i + 2);
              if (j !== -1) {
                const format = result.substring(i + prefix.length + 1, j);
                //result.substring(firstChar + prefix.length, lastChar - 1)
                //format is the data between that we're trying to format ?
                if (format) {
                  let formattedParam = null;
                  if (typeof param === "number") {
                    const enumProvider = ServiceProvider$1.findEnumProvider();
                    //number
                    if (format === "c" || format === "C") {
                      formattedParam = this.toCurrencyString(param);
                    } else if (format === "0" || format === "n" || format === "N") {
                      formattedParam = param.toFixed(0).toString();
                    } else if (format === "00") {
                      param = param.toFixed(0);
                      formattedParam = param >= 0 && param < 10 ? "0" + param : param.toString();
                    } else if (format === "0.0") {
                      formattedParam = param.toFixed(1).toString();
                    } else if (format === "0.00") {
                      formattedParam = param.toFixed(2).toString();
                    } else if (format === "%" || format === "0%") {
                      formattedParam = Math.round(param) + "%";
                    } else if (format === "0.0%") {
                      formattedParam = param.toFixed(1) + "%";
                    } else if (format === "0.00%") {
                      formattedParam = param.toFixed(2) + "%";
                    } else if (enumProvider && enumProvider.isEnum(format)) {
                      formattedParam = enumProvider.getEnumText(format, param);
                    }
                  } else if (typeof param === "string" || typeof param === "object" && param.constructor.name === Date.name) {
                    if (format === "dddd") {
                      //The abbreviated name of the day of the week.
                      formattedParam = this.getDayOfWeek(param);
                    } else if (format === "ddd") {
                      //The abbreviated name of the day of the week.
                      formattedParam = this.getShortDayOfWeek(param);
                    } else if (format === "MMMM") {
                      //The abbreviated name of the month.
                      formattedParam = this.getMonth(param);
                    } else if (format === "MMM") {
                      //The abbreviated name of the month.
                      formattedParam = this.getShortMonth(param);
                    } else if (format === "D" || format === "dd.MM.yyyy") {
                      const date = new Date(param);
                      formattedParam = this.toDateString(date);
                    } else if (format === "G") {
                      const date = new Date(param);
                      formattedParam = this.toDateTimeString(date);
                    } else if (format === "g") {
                      const date = new Date(param);
                      formattedParam = this.toDateShortTimeString(date);
                    } else if (format === "gt") {
                      const date = new Date(param);
                      formattedParam = this.toDateNameTimeString(date);
                    } else if (format === "t" || format == "HH:mm") {
                      const date = new Date(param);
                      formattedParam = this.toShortTimeString(date);
                    } else if (format === "HH:mm:ss") {
                      const date = new Date(param);
                      formattedParam = this.toTimeString(date);
                    } else if (format === "MM.yyyy") {
                      const date = new Date(param);
                      formattedParam = `${Utility.pad(date.getMonth() + 1)}.${date.getFullYear()}`;
                    } else if (format === "dd.MM") {
                      const date = new Date(param);
                      formattedParam = `${Utility.pad(date.getDate())}.${Utility.pad(date.getMonth() + 1)}`;
                    } else if (format === "d" || format === "dd.MM.yy") {
                      const date = new Date(param);
                      formattedParam = this.toShortDateString(date);
                    } else if (format === "dt" || format === "dd.MM.yy HH:mm") {
                      const date = new Date(param);
                      formattedParam = this.toShortDateShortTimeString(date);
                    }
                  } else if (typeof param === "object" && (param instanceof TimeSpan || param.isTimeSpan === true)) {
                    const value = param;
                    if (format === "hh:mm:ss") {
                      formattedParam = `${Utility.pad(value.hours)}:${Utility.pad(value.minutes)}:${Utility.pad(value.seconds)}`;
                    } else if (format === "c") {
                      formattedParam = value.days > 0 ? `${value.days}.${Utility.pad(value.hours)}:${Utility.pad(value.minutes)}:${Utility.pad(value.seconds)}` : `${Utility.pad(value.hours)}:${Utility.pad(value.minutes)}:${Utility.pad(value.seconds)}`;
                    }
                  }
                  if (formattedParam != null) {
                    result = result.substring(0, i) + formattedParam + result.substring(j + 1);
                  }
                }
              }
            }
          } else {
            let str = "";
            if (param != null) {
              const transformProvider = ServiceProvider$1.findTransformProvider();
              str = transformProvider ? transformProvider.toString(param) : param.toString();
            }
            result = result.replace(`{${index}}`, str);
          }
          i = result.indexOf(prefix, i + 1);
        }
      });
    }
    return result;
  }
  static formatValue(value, format = null) {
    return value != null ? format ? typeof format === "function" ? format(value) : Utility.format(`{0:${format}}`, value) : Utility.format(`{0}`, value) : "";
  }
  static getDayOfWeek(dayOfWeekOrDate) {
    switch (typeof dayOfWeekOrDate) {
      case "string":
        dayOfWeekOrDate = new Date(dayOfWeekOrDate);
        return this.getDayOfWeek(dayOfWeekOrDate);
      case "number":
        {
          let name;
          switch (dayOfWeekOrDate) {
            case 0:
              name = "Sunday";
              break;
            case 1:
              name = "Monday";
              break;
            case 2:
              name = "Tuesday";
              break;
            case 3:
              name = "Wednesday";
              break;
            case 4:
              name = "Thursday";
              break;
            case 5:
              name = "Friday";
              break;
            case 6:
              name = "Saturday";
              break;
            default:
              throw Error(`Unsupported day of week number "${dayOfWeekOrDate}", can be [0..6] => [Sunday..Saturday].`);
          }
          const localizer = ServiceProvider$1.findLocalizer();
          let language = navigator.language;
          if (localizer) {
            const tag = `DayOfWeek.${name}`;
            if (localizer.contains(tag)) {
              return localizer.get(tag);
            }
            language = localizer.language;
          }
          const sunday = new Date(Date.UTC(2017, 0, 1));
          const dayOfWeek = sunday.addDays(dayOfWeekOrDate);
          name = dayOfWeek.toLocaleString(language, {
            weekday: "long"
          });
          return name;
        }
      case "object":
        if (typeof dayOfWeekOrDate.getDay === "function") {
          dayOfWeekOrDate = dayOfWeekOrDate.getDay();
          return this.getDayOfWeek(dayOfWeekOrDate);
        }
        break;
    }
    throw Error(`Unsupported type for day of week "${dayOfWeekOrDate}", can be number, string or Date.`);
  }
  static getShortDayOfWeek(dayOfWeekOrDate) {
    const dayOfWeek = this.getDayOfWeek(dayOfWeekOrDate);
    return dayOfWeek.substr(0, 2);
  }
  static getShortMonth(monthOrDate) {
    const month = this.getMonth(monthOrDate);
    return month.substr(0, 3);
  }
  static getMonth(monthOrDate) {
    if (Utility.isDateType(monthOrDate)) {
      monthOrDate = monthOrDate.getMonth();
      return this.getMonth(monthOrDate);
    }
    if (typeof monthOrDate === "string") {
      monthOrDate = monthOrDate.toLowerCase();
    }
    const localizer = ServiceProvider$1.findLocalizer();
    switch (monthOrDate) {
      case "january":
      case 0:
        return localizer ? localizer.get("Month.January") : "January";
      case "february":
      case 1:
        return localizer ? localizer.get("Month.February") : "February";
      case "march":
      case 2:
        return localizer ? localizer.get("Month.March") : "March";
      case "april":
      case 3:
        return localizer ? localizer.get("Month.April") : "April";
      case "may":
      case 4:
        return localizer ? localizer.get("Month.May") : "May";
      case "june":
      case 5:
        return localizer ? localizer.get("Month.June") : "June";
      case "july":
      case 6:
        return localizer ? localizer.get("Month.July") : "July";
      case "august":
      case 7:
        return localizer ? localizer.get("Month.August") : "August";
      case "september":
      case 8:
        return localizer ? localizer.get("Month.September") : "September";
      case "october":
      case 9:
        return localizer ? localizer.get("Month.October") : "October";
      case "november":
      case 10:
        return localizer ? localizer.get("Month.November") : "November";
      case "december":
      case 11:
        return localizer ? localizer.get("Month.December") : "December";
    }
    throw Error(`Unsupported month "${monthOrDate}", can be number ([0..11]), string (month name in English) or Date.`);
  }
  static toCurrencyString(input) {
    return input.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
  }
  static addDays(date, days) {
    const copy = new Date(date);
    copy.setDate(copy.getDate() + days);
    return copy;
  }
  static addMonths(date, months) {
    date = new Date(date);
    const day = date.getDate();
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    date.setDate(Math.min(day, this.getDaysInMonth(date)));
    return date;
  }
  static addYears(date, years) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + years);
    return date;
  }
  static addMilliseconds(date, milliseconds) {
    date = new Date(date);
    date.setMilliseconds(date.getMilliseconds() + milliseconds);
    return date;
  }
  static isLeapYear(year = null) {
    return year != null ? year % 4 === 0 && year % 100 !== 0 || year % 400 === 0 : this.isLeapYear(this.now().getFullYear());
  }
  static getDaysInMonth(date) {
    date = new Date(date);
    const year = date.getFullYear();
    const month = date.getMonth();
    return [31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
  }
  static distance(x, y) {
    return Math.sqrt(Math.pow(y.lat - x.coords.latitude, 2) + Math.pow(y.lon - x.coords.longitude, 2));
  }
  static max(items, callback = null) {
    if (items.length === 0) throw Error("Array cannot be empty.");
    callback = callback || (item => item);
    let maxItem = items[0];
    let maxValue = callback(maxItem);
    const length = items.length;
    for (let i = 1; i < length; i++) {
      const item = items[i];
      const value = callback(item);
      if (value > maxValue) {
        maxValue = value;
        maxItem = item;
      }
    }
    return maxItem;
  }
  static maxValue(items, callback) {
    return callback(Utility.max(items, callback));
  }
  static min(items, callback = null) {
    if (items.length === 0) throw Error("Array cannot be empty.");
    callback = callback || (item => item);
    let minItem = items[0];
    let minValue = callback(minItem);
    const length = items.length;
    for (let i = 1; i < length; i++) {
      const item = items[i];
      const value = callback(item);
      if (value < minValue) {
        minValue = value;
        minItem = item;
      }
    }
    return minItem;
  }
  static minValue(items, callback) {
    return callback(Utility.min(items, callback));
  }
  static sum(items, callback) {
    let sum = 0;
    if (items) {
      items.forEach(item => sum += callback(item) || 0);
    }
    return sum;
  }
  static count(items, callback) {
    let count = 0;
    if (items) {
      items.forEach((item, index) => count += callback(item, index) ? 1 : 0);
    }
    return count;
  }
  static digits(value) {
    value = Math.abs(value);
    value = Math.trunc(value);
    return value.toString().length;
  }
  static round(value, digits = 0) {
    digits = Math.round(digits);
    if (digits > 0) {
      const intDigits = this.digits(value);
      const totalDigits = intDigits + digits;
      const maxDigits = 18;
      if (totalDigits > maxDigits) {
        digits -= totalDigits - maxDigits;
        if (digits <= 0) {
          return Math.round(value);
        }
      }
      const k = Math.pow(10, digits);
      value *= k;
      value = Math.round(value);
      value /= k;
    }
    return value;
  }
  static roundE(value) {
    return this.round(value, 10);
  }
  static roundHalf(value) {
    return Math.round(value * 2) / 2;
  }
  static forEachAsync(items, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      const promises = items.map(item => callback(item));
      yield Promise.all(promises);
    });
  }
  static where(items, predicate) {
    return items.filter(predicate);
  }
  static selectMany(items, collectionSelector) {
    const result = [];
    const length = items.length;
    for (let i = 0; i < length; i++) {
      const subItems = collectionSelector(items[i]);
      result.push(...subItems);
    }
    return result;
  }
  static whereAsync(items, callback) {
    return __awaiter(this, void 0, void 0, function* () {
      return items.filter(item => __awaiter(this, void 0, void 0, function* () {
        return yield callback(item);
      }));
    });
  }
  static groupBy(items, callback = null) {
    const map = new Map();
    items.forEach(item => {
      const key = callback ? callback(item) : null;
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return Array.from(map.values());
  }
  static distinct(items, callback = null) {
    const dict = new Dictionary();
    items.forEach(item => dict.setValue(callback ? callback(item) : item, item));
    return dict.values();
  }
  static remove(items, item) {
    if (Array.isArray(item)) {
      const length = item.length;
      for (let i = 0; i < length; i++) {
        Utility.remove(items, item[i]);
      }
    } else {
      const index = items.indexOf(item);
      if (index !== -1) {
        items.splice(index, 1);
      }
    }
  }
  static removeAt(items, index) {
    if (index < 0 || index >= items.length) throw Error(`Array index "${index}" out of range, can be in [0..${items.length}].`);
    items.splice(index, 1);
  }
  /**
   * @param value Number to create a padded string from.
   * @return The number as a string, with an added leading zero if the number is smaller than 10.
   */
  static pad(value) {
    value = Math.floor(Math.abs(value));
    return (value < 10 ? "0" : "") + value;
  }
  /**
   * @return A new {@link Date} with the browsers current date, time and time-zone.
   */
  static now() {
    return new Date();
  }
  /**
   * @return A new {@link Date} with the browsers current date, time and time-zone, with its time-component adjusted to look like it is in UTC time.
   * @see toUtc
   */
  static utcNow() {
    const now = Utility.now();
    return Utility.toUtc(now);
  }
  /**
   * @see date
   */
  static today() {
    return Utility.date();
  }
  static tomorrow() {
    return this.today().addDays(1);
  }
  static getFirstDayOfWeek(date) {
    date = date !== null && date !== void 0 ? date : this.today();
    const newDate = date.getDate() - date.getDay() + (date.isSunday() ? -6 : 1);
    return new Date(date.setDate(newDate));
  }
  static getLastDayOfWeek(date) {
    date = date !== null && date !== void 0 ? date : this.today();
    const newDate = date.getFirstDayOfWeek().getDate() + 6;
    return new Date(date.setDate(newDate));
  }
  static getFirstDayOfMonth(date) {
    date = date !== null && date !== void 0 ? date : this.today();
    const currentMonth = date.getMonth();
    return new Date(date.setMonth(currentMonth, 1));
  }
  static getLastDayOfMonth(date) {
    date = date !== null && date !== void 0 ? date : this.today();
    const nextMonth = date.getMonth() + 1;
    return new Date(date.setMonth(nextMonth, 0));
  }
  static getISOWeekNumber(date) {
    date = date !== null && date !== void 0 ? date : this.today();
    const oneDayValue = 86400000;
    const thursday = date.getFirstDayOfWeek().addDays(3);
    const year = thursday.getFullYear();
    const firstWeek = new Date(year, 0, 4);
    const weekNumber = 1 + Math.round((thursday.valueOf() - firstWeek.valueOf()) / oneDayValue / 7);
    return weekNumber;
  }
  /**
   * A new {@link Date} with the browsers current date and time-zone, with its time-zone specific time-component set to 0.
   * @see getDateWithoutTime
   */
  static date() {
    return this.getDateWithoutTime(this.now());
  }
  static inInterval(date, from, to) {
    const dateValue = new Date(date).valueOf();
    const fromValue = from != null ? new Date(from).valueOf() : 0;
    const toValue = to != null ? new Date(to).valueOf() : Number.MAX_VALUE;
    return fromValue <= dateValue && dateValue <= toValue;
  }
  static inFuture(date) {
    return date != null && Utility.diff(date, Utility.now()).totalMilliseconds > 0;
  }
  static inPast(date) {
    return date != null && Utility.diff(Utility.now(), date).totalMilliseconds > 0;
  }
  /**
   * NOTE: The output {@link Date} is still in the browsers time-zone!
   *
   * @return A new {@link Date} with its time-component adjusted to look like it is in UTC time.
   */
  static toUtc(date) {
    date = new Date(date);
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  }
  /**
   * Create a copy of the input {@link Date} and add the {@link timezoneOffset} to it.
   * This makes the output {@link Date}'s internal UTC date- and time-components equal to the input {@link Date}'s timezone-specific ones.
   * Extremely useful when making sure {@link Date}'s are serialized properly.
   *
   * Example:
   *      Browsers timezone is UTC+2.
   *      Input {@link Date} is 2000-01-01-00-00-00, and thus the output {@link Date} is 2000-01-01-02-00-00.
   *      The input date would be serialized as "1999-12-31T22:00:00.000Z", whereas the output date would be serialized as "2000-01-01T00:00:00.000Z".
   *
   * @see utcValueOf
   */
  static asUtc(date) {
    return new Date(Utility.utcValueOf(date));
  }
  static toLocal(date) {
    date = new Date(date);
    const hoursDiff = date.getHours() - date.getTimezoneOffset() / 60;
    date.setHours(hoursDiff);
    return date;
  }
  static utcValueOf(date) {
    if (typeof date === "string") {
      date = new Date(date);
    }
    return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
  }
  static isSunday(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    return value.getDay() == 0;
  }
  static isToday(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    const today = this.today();
    return value.getDate() === today.getDate() && value.getMonth() === today.getMonth() && value.getFullYear() === today.getFullYear();
  }
  /**
   * @return The input {@link Date}'s date-component in ISO 8601 format (yyyy-mm-dd)
   */
  static toISODateString(date) {
    return date.getFullYear() + "-" + Utility.pad(date.getMonth() + 1) + "-" + Utility.pad(date.getDate());
  }
  /**
   * @return The input {@link Date}'s date-component, time-component and timezone in ISO 8601 format (yyyy-mm-ddThh:MM:ss+Z:Z)
   */
  static toLongISOString(date) {
    const tzo = -date.getTimezoneOffset();
    const dif = tzo >= 0 ? "+" : "-";
    return date.getFullYear() + "-" + Utility.pad(date.getMonth() + 1) + "-" + Utility.pad(date.getDate()) + "T" + Utility.pad(date.getHours()) + ":" + Utility.pad(date.getMinutes()) + ":" + Utility.pad(date.getSeconds()) + dif + Utility.pad(tzo / 60) + ":" + Utility.pad(tzo % 60);
  }
  static toDateTimeString(date) {
    return `${Utility.toDateString(date)} ${Utility.toTimeString(date)}`;
  }
  /**
   * Example of output: Wednesday, August 19, 11:30
   */
  static toDateNameTimeString(date) {
    return `${Utility.getDayOfWeek(date)}, ${Utility.getMonth(date)} ${date.getDate()}, ${Utility.toShortTimeString(date)}`;
  }
  static toShortDateString(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    const year = value.getFullYear().toString().substr(2);
    return `${Utility.pad(value.getDate())}.${Utility.pad(value.getMonth() + 1)}.${year}`;
  }
  static toTimeString(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    return `${Utility.pad(value.getHours())}:${Utility.pad(value.getMinutes())}:${Utility.pad(value.getSeconds())}`;
  }
  static toDateShortTimeString(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    return this.toDateString(value) + " " + this.toShortTimeString(value);
  }
  static toShortDateShortTimeString(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    return `${this.toShortDateString(value)} ${this.toShortTimeString(value)}`;
  }
  static toDateString(date) {
    const value = typeof date === "string" ? new Date(date) : date;
    return `${Utility.pad(value.getDate())}.${Utility.pad(value.getMonth() + 1)}.${value.getFullYear()}`;
  }
  static toShortTimeString(date) {
    return `${Utility.pad(date.getHours())}:${Utility.pad(date.getMinutes())}`;
  }
  /**
   * @return Copy of the input {@link Date} with its timezone-specific time-component set to 0.
   */
  static getDateWithoutTime(date) {
    const copy = new Date(date);
    copy.setHours(0, 0, 0, 0);
    return copy;
  }
  /**
   * Difference in minutes between the browsers time-zone and UTC.
   */
  static get timezoneOffset() {
    const timezoneOffset = new Date().getTimezoneOffset();
    return -timezoneOffset;
  }
  static diff(x, y, ignoreTimeZone = false) {
    if (typeof x === "string") {
      x = new Date(x);
    }
    if (typeof y === "string") {
      y = new Date(y);
    }
    const xDate = ignoreTimeZone ? x.utcValueOf() : x.valueOf();
    const yDate = ignoreTimeZone ? y.utcValueOf() : y.valueOf();
    const mlsec = xDate - yDate;
    return TimeSpan.fromMilliseconds(mlsec);
  }
  /**
   * Checks if global click happened outside of component
   * @param target - target of click event
   * @param id - id of the component
   * @param exceptId - id of the exception component to not trigger outside click (default null)
   * @param exceptTag - string value of HTML tag that is inside excepted container, but triggers outside click (for case when there are multiple children inside excepted container
   * @returns boolean - true/false if global click happened outside of the component
   */
  static clickedOutside(target, id, exceptId = null, exceptTag = null) {
    const container = document.querySelector(`#${id}`);
    let outside = container !== null && !container.contains(target);
    if (outside && exceptId) {
      const exceptedContainer = document.querySelector(`#${exceptId}`);
      if (exceptedContainer !== null) {
        outside = !exceptedContainer.contains(target);
      }
      if (exceptTag && exceptedContainer) {
        const exceptedFound = exceptedContainer.getElementsByTagName(exceptTag)[0];
        if (exceptedFound && target === exceptedFound) {
          outside = true;
        }
      }
    }
    return outside;
  }
  static readUploadedFileAsDataUrl(inputFile) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileReader = new FileReader();
      return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
          fileReader.abort();
          reject(new DOMException("Problem parsing input file."));
        };
        fileReader.onload = () => {
          const result = fileReader.result || "";
          resolve(result);
        };
        fileReader.readAsDataURL(inputFile);
      });
    });
  }
  static readUploadedFileAsBinaryString(inputFile) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileReader = new FileReader();
      return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
          fileReader.abort();
          reject(new DOMException("Problem parsing input file."));
        };
        fileReader.onload = () => {
          const result = fileReader.result || "";
          resolve(result);
        };
        fileReader.readAsBinaryString(inputFile);
      });
    });
  }
  static readUploadedFileAsArrayBuffer(inputFile) {
    return __awaiter(this, void 0, void 0, function* () {
      const fileReader = new FileReader();
      return new Promise((resolve, reject) => {
        fileReader.onerror = () => {
          fileReader.abort();
          reject(new DOMException("Problem parsing input file."));
        };
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
        fileReader.readAsArrayBuffer(inputFile);
      });
    });
  }
  static getFileExtension(name) {
    if (name) {
      const index = name.lastIndexOf(".");
      if (index !== -1 && index < name.length) {
        return name.substr(index);
      }
    }
    return "";
  }
  static toBlob(file, sliceSize = 512) {
    const src = file.src.includes(",") ? file.src.split(",")[1].trim() : file.src;
    const byteCharacters = atob(src);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
      type: file.type
    });
  }
  /**
   * @param src
   * @return true if 'src' is a decodable string.
   */
  static isStrDecodable(src) {
    try {
      window.atob(src);
      return true;
    } catch (e) {
      return false;
    }
  }
  static toObjectUrl(file, sliceSize = 512) {
    const blob = Utility.toBlob(file, sliceSize);
    return URL.createObjectURL(blob);
  }
  /**
   * @param mimeType mimeType to update
   * @return if mimeType is known then it will return the new version otherwise it will return the given mimeType
   */
  static overwriteDeprecatedMimeTypes(mimeType) {
    if (mimeType === "application/font-woff") {
      return "font/woff";
    }
    return mimeType;
  }
  /**
   * some browsers returns some deprecated mimeTypes as part of DataUrl, this method will try to update the known ones.
   * @param dataUrl output of fileReader {@see readUploadedFileAsDataUrl}
   * @param fileExtension file extension with dot {@see getFileExtension}
   */
  static overwriteDeprecatedMimeTypeInDataUrl(dataUrl, fileExtension) {
    if (fileExtension === ".woff" && dataUrl.startsWith("data:application/font-woff")) {
      return dataUrl.replace("data:application/font-woff", "data:font/woff");
    }
    if (fileExtension === ".woff" && dataUrl.startsWith("data:application/octet-stream")) {
      return dataUrl.replace("data:application/octet-stream", "data:font/woff");
    }
    if (fileExtension === ".woff2" && dataUrl.startsWith("data:application/octet-stream")) {
      return dataUrl.replace("data:application/octet-stream", "data:font/woff2");
    }
    return dataUrl;
  }
  /**
   * some browsers don't return mimeType for some file extension so this method will try to return the correct mimeType.
   * @param fileExtension file extension with dot {@see getFileExtension}
   */
  static getKnownMimeTypesByFileExtension(fileExtension) {
    if (fileExtension === ".woff") {
      return "font/woff";
    }
    if (fileExtension === ".woff2") {
      return "font/woff2";
    }
    if (fileExtension === ".ttf") {
      return "font/ttf";
    }
    if (fileExtension === ".otf") {
      return "font/otf";
    }
    return null;
  }
  static transformFileAsync(fileReference) {
    return __awaiter(this, void 0, void 0, function* () {
      if (fileReference) {
        const dataUrl = yield Utility.readUploadedFileAsDataUrl(fileReference);
        if (dataUrl) {
          const fileExtension = this.getFileExtension(fileReference.name);
          const checkedDataUrl = Utility.overwriteDeprecatedMimeTypeInDataUrl(dataUrl, fileExtension);
          const checkedMimeType = Utility.overwriteDeprecatedMimeTypes(fileReference.type);
          const file = new FileModel();
          file.lastModified = new Date(fileReference.lastModified);
          file.name = fileReference.name;
          file.size = fileReference.size;
          file.type = checkedMimeType || Utility.getKnownMimeTypesByFileExtension(fileExtension) || fileExtension;
          file.src = checkedDataUrl;
          return file;
        }
      }
      return null;
    });
  }
  static base64FromDataUrl(dataUrl) {
    return dataUrl.split("base64,")[1];
  }
  static toPagedList(items, pageNumber, pageSize) {
    const firstIndex = (pageNumber - 1) * pageSize;
    const totalItemCount = items.length;
    let pageCount = Math.trunc(totalItemCount / pageSize);
    if (pageCount === 0) {
      pageCount = 1;
    } else if (totalItemCount > pageCount * pageSize) {
      pageCount++;
    }
    const pageItems = items.slice(firstIndex, firstIndex + pageSize);
    return {
      items: pageItems,
      pageCount: pageCount,
      pageSize: pageSize,
      totalItemCount: totalItemCount,
      pageNumber: pageNumber
    };
  }
  static reTryAsync(action, delay = 100, attempts = 3) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        return yield action();
      } catch (e) {
        if (attempts <= 0) {
          throw e;
        }
        if (delay > 0) {
          yield Utility.wait(100);
        }
        return this.reTryAsync(action, delay, attempts - 1);
      }
    });
  }
  static findInstanceByAccessor(instance, accessor) {
    if (instance == null || accessor == null || typeof instance !== "object") {
      return undefined;
    }
    accessor = accessor.replace(/\[(\w+)]/g, '.$1'); // convert indexes to properties
    accessor = accessor.replace(/^\./, ''); // strip a leading dot
    const path = accessor.split('.');
    const length = path.length;
    let tuple;
    for (let i = 0, n = length; i < n; ++i) {
      const key = path[i];
      if (instance == null || !(key in instance)) {
        return undefined;
      }
      tuple = [instance, key];
      instance = instance[key];
      if (instance == null && i === n) {
        return undefined;
      }
    }
    return tuple;
  }
  static findValueByAccessor(instance, accessor) {
    if (typeof accessor == "string") {
      const tuple = this.findInstanceByAccessor(instance, accessor);
      if (tuple) {
        instance = tuple[0];
        accessor = tuple[1];
        return instance[accessor];
      }
      return undefined;
    }
    const length = accessor.length;
    for (let i = 0; i < length; i++) {
      const value = Utility.findValueByAccessor(instance, accessor[i]);
      if (value !== undefined) {
        return value;
      }
    }
    return undefined;
  }
  static findStringValueByAccessor(instance, accessor) {
    if (typeof accessor == "string") {
      const value = Utility.findValueByAccessor(instance, accessor);
      if (value != null && typeof value == "string" && value.length > 0) {
        return value;
      }
      return null;
    }
    const length = accessor.length;
    for (let i = 0; i < length; i++) {
      const value = Utility.findValueByAccessor(instance, accessor[i]);
      if (value != null && typeof value == "string" && value.length > 0) {
        return value;
      }
    }
    return null;
  }
  static setValueByAccessor(instance, accessor, value) {
    const tuple = this.findInstanceByAccessor(instance, accessor);
    if (tuple) {
      instance = tuple[0];
      accessor = tuple[1];
      instance[accessor] = value;
    }
  }
  static getHashCode(value) {
    return HashCodeUtility.getHashCode(value);
  }
  /**
   * @param date Value to check for Dateness
   * @return Is the value a {@link Date} or a {@link string} representing a date.
   */
  static isDateType(date) {
    return date != null && (typeof date === "object" && date.constructor === Date || typeof date === "string" && !!date.match(AthenaeumConstants.dateRegex));
  }
  static restoreDate(model, path = "") {
    if (model != null) {
      if (typeof model === "object") {
        for (const property in model) {
          if (Object.hasOwnProperty.call(model, property)) {
            const value = model[property];
            if (value != null) {
              let isDateStr = false;
              if (value.constructor === String) {
                // "yyyy-MM-ddThh:mm:ss.sssZ"
                // "2019-09-25T16:00:20.817Z"
                // "2019-09-25T16:00:20.817"
                // "2019-09-25"
                // "2019-09-24T00:00:00"
                // "2019-09-24T00:00:00Z"
                // "2019-10-14T21:00:00.000Z"
                // "2019-10-16T00:00:00+03:00"
                let dateStr = value;
                isDateStr = !!dateStr.match(AthenaeumConstants.dateRegex);
                if (isDateStr) {
                  const markedAsUtc = dateStr.endsWith("Z");
                  const includesTimezoneOffset = !markedAsUtc && dateStr.includes("+");
                  if (!includesTimezoneOffset) {
                    if (markedAsUtc) {
                      dateStr = dateStr.slice(0, -1);
                    }
                    const includesTime = dateStr.includes("T");
                    if (includesTime) {
                      const dateWithoutTime = !!dateStr.match(AthenaeumConstants.zeroTimeRegex);
                      if (!dateWithoutTime) {
                        // Time from server always in UTC!
                        dateStr += "Z";
                      }
                    } else {
                      dateStr += "T00:00:00Z";
                    }
                  }
                  model[property] = new Date(dateStr);
                }
              }
              if (!isDateStr) {
                this.restoreDate(value, path + "." + property);
              }
            }
          }
        }
      }
    }
    return model;
  }
  /**
   * @param object Value to clone.
   * @return
   *  If the {@link object} is null, {@link NEGATIVE_INFINITY}, {@link POSITIVE_INFINITY}, {@link NaN}, or an invalid date: null;
   *
   *  If the {@link object} is a negative zero: positive zero;
   *
   *  If the {@link object} is a {@link boolean}, {@link number}, {@link string} or {@link undefined}: the input {@link object};
   *
   *  If the {@link object} is a {@link Date}: string representation of the date;
   *
   *  If the {@link object} is an {@link Array}: deep clone of the {@link object} with {@link function}, {@link Symbol} and {@link undefined} values set to null, and {@link Date} values converted to strings;
   *
   *  Otherwise: deep clone of the {@link object} without {@link function}, {@link Symbol} and {@link undefined} properties, and with {@link Date} properties values converted to strings.
   *
   * @throws Error if {@link object} is a {@link BigInt}, {@link function} or a {@link Symbol}, or is an object which contains a {@link BigInt}.
   */
  static clone(object) {
    if (object == null) {
      return object;
    }
    const json = JSON.stringify(object);
    return JSON.parse(json);
  }
  static copyTo(from, ...to) {
    if (from == null) {
      return;
    }
    if (from instanceof Dictionary) {
      from.keys().forEach(key => {
        const value = from.getValue(key);
        to.forEach(instance => Utility.setValueByAccessor(instance, key, value));
      });
      return;
    }
    const copy = this.clone(from);
    for (const key in copy) {
      if (Object.hasOwnProperty.call(copy, key)) {
        const value = Utility.findValueByAccessor(from, key);
        if (value !== undefined) {
          to.forEach(instance => Utility.setValueByAccessor(instance, key, value));
        }
      }
    }
  }
  static getExtensionsFromMimeTypes(mimeTypes) {
    if (mimeTypes.length && mimeTypes.every(type => type.includes("/"))) {
      return mimeTypes.map(type => type.split("/")[1]).join(", ");
    }
    return "";
  }
  /**
   * @returns A unique number.
   */
  static getId() {
    return ++this._number;
  }
  /**
   * @returns An underscore with a unique number appended to it.
   */
  static getComponentId() {
    return `_${this.getId()}`;
  }
}
Utility._geoEnabled = null;
Utility._number = 1;
var Utility$1 = Utility;
//Register Extensions
DateExtensions();
StringExtensions();
ArrayExtensions();
NumberExtensions();

class TimeSpan {
  /**
   * Initializes a new instance of the TimeSpan structure to a specified number of days, hours, minutes, seconds, and milliseconds.
   * @param days - Number of days.
   * @param hours - Number of hours.
   * @param minutes - Number of minutes.
   * @param seconds - Number of seconds.
   * @param milliseconds - Number of milliseconds.
   */
  constructor(days = 0, hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
    this.isTimeSpan = true;
    this._totalMilliseconds = (days * 3600 * 24 + hours * 3600 + minutes * 60 + seconds) * 1000 + milliseconds;
  }
  /**
   * Gets the value of the current TimeSpan structure expressed in whole and fractional milliseconds.
   */
  get totalMilliseconds() {
    return this._totalMilliseconds;
  }
  /**
   * Gets the value of the current TimeSpan structure expressed in whole and fractional seconds.
   */
  get totalSeconds() {
    return this._totalMilliseconds / TimeSpan.millisecondsPerSecond;
  }
  /**
   * Gets the value of the current TimeSpan structure expressed in whole and fractional minutes.
   */
  get totalMinutes() {
    return this._totalMilliseconds / TimeSpan.millisecondsPerMinute;
  }
  /**
   * Gets the value of the current TimeSpan structure expressed in whole and fractional hours.
   */
  get totalHours() {
    return this._totalMilliseconds / TimeSpan.millisecondsPerHour;
  }
  /**
   * Gets the value of the current TimeSpan structure expressed in whole and fractional days.
   */
  get totalDays() {
    return this._totalMilliseconds / TimeSpan.millisecondsPerDay;
  }
  /**
   * Gets the days component of the time interval represented by the current TimeSpan structure.
   */
  get days() {
    return Math.trunc(this.totalDays);
  }
  /**
   * Gets the hours component of the time interval represented by the current TimeSpan structure.
   */
  get hours() {
    return Math.trunc((this._totalMilliseconds - TimeSpan.millisecondsPerDay * this.days) / TimeSpan.millisecondsPerHour);
  }
  /**
   * Gets the minutes component of the time interval represented by the current TimeSpan structure.
   */
  get minutes() {
    return Math.trunc((this._totalMilliseconds - TimeSpan.millisecondsPerDay * this.days - TimeSpan.millisecondsPerHour * this.hours) / TimeSpan.millisecondsPerMinute);
  }
  /**
   * Gets the seconds component of the time interval represented by the current TimeSpan structure.
   */
  get seconds() {
    return Math.trunc((this._totalMilliseconds - TimeSpan.millisecondsPerDay * this.days - TimeSpan.millisecondsPerHour * this.hours - TimeSpan.millisecondsPerMinute * this.minutes) / TimeSpan.millisecondsPerSecond);
  }
  /**
   * Gets the milliseconds component of the time interval represented by the current TimeSpan structure.
   */
  get milliseconds() {
    return Math.trunc(this._totalMilliseconds - TimeSpan.millisecondsPerDay * this.days - TimeSpan.millisecondsPerHour * this.hours - TimeSpan.millisecondsPerMinute * this.minutes - TimeSpan.millisecondsPerSecond * this.seconds);
  }
  /**
   * Returns a new TimeSpan object whose value is the sum of the specified TimeSpan object and this instance.
   * @param ts - The time interval to add.
   * @returns TimeSpan - A new object that represents the value of this instance plus the value of ts.
   */
  add(ts) {
    const result = new TimeSpan();
    result._totalMilliseconds = this._totalMilliseconds + ts._totalMilliseconds;
    return result;
  }
  /**
   * Returns a new TimeSpan object whose value is the difference between the specified TimeSpan object and this instance.
   * @param ts - The time interval to be subtracted.
   * @returns TimeSpan - A new time interval whose value is the result of the value of this instance minus the value of ts.
   */
  subtract(ts) {
    const result = new TimeSpan();
    result._totalMilliseconds = this._totalMilliseconds - ts._totalMilliseconds;
    return result;
  }
  /**
   * Returns a new TimeSpan object which value is the result of multiplication of this instance and the specified factor.
   * @param factor - The value to be multiplied by.
   * @returns TimeSpan - A new object that represents the value of this instance multiplied by the value of factor.
   */
  multiply(factor) {
    const result = new TimeSpan();
    result._totalMilliseconds = this._totalMilliseconds * factor;
    return result;
  }
  /**
   * Returns a new TimeSpan object whose value is the negated value of this instance.
   * @returns TimeSpan - A new object with the same numeric value as this instance, but with the opposite sign.
   */
  negate() {
    const result = new TimeSpan();
    result._totalMilliseconds = -this._totalMilliseconds;
    return result;
  }
  toTimeString() {
    return `${Utility$1.pad(this.hours)}:${Utility$1.pad(this.minutes)}:${Utility$1.pad(this.seconds)}`;
  }
  toShortTimeString() {
    return `${Utility$1.pad(this.hours)}:${Utility$1.pad(this.minutes)}`;
  }
  /**
   * Returns a TimeSpan that represents a specified number of days, where the specification is accurate to the nearest millisecond.
   * @param days - A number of days, accurate to the nearest millisecond.
   * @returns TimeSpan - An object that represents value.
   */
  static fromDays(days) {
    return TimeSpan.fromMilliseconds(days * TimeSpan.millisecondsPerDay);
  }
  /**
   * Returns a TimeSpan that represents a specified number of hours, where the specification is accurate to the nearest millisecond.
   * @param hours - A number of hours accurate to the nearest millisecond.
   * @returns TimeSpan - An object that represents value.
   */
  static fromHours(hours) {
    return TimeSpan.fromMilliseconds(hours * TimeSpan.millisecondsPerHour);
  }
  /**
   * Returns a TimeSpan that represents a specified number of minutes, where the specification is accurate to the nearest millisecond.
   * @param minutes - A number of minutes, accurate to the nearest millisecond.
   * @returns TimeSpan - An object that represents value.
   */
  static fromMinutes(minutes) {
    return TimeSpan.fromMilliseconds(minutes * TimeSpan.millisecondsPerMinute);
  }
  /**
   * Returns a TimeSpan that represents a specified number of seconds, where the specification is accurate to the nearest millisecond.
   * @param seconds - A number of seconds, accurate to the nearest millisecond.
   * @returns TimeSpan - An object that represents value.
   */
  static fromSeconds(seconds) {
    return TimeSpan.fromMilliseconds(seconds * TimeSpan.millisecondsPerSecond);
  }
  /**
   * Returns a TimeSpan that represents a specified number of milliseconds.
   * @param milliseconds - A number of milliseconds.
   * @returns TimeSpan - An object that represents value.
   */
  static fromMilliseconds(milliseconds) {
    const result = new TimeSpan();
    result._totalMilliseconds = Math.round(milliseconds);
    return result;
  }
  /**
   * Compares this instance to a specified TimeSpan object and returns an integer that indicates whether this instance is shorter than, equal to, or longer than the TimeSpan object.
   * @param value - An object to compare to this instance.
   * @returns number - A signed number indicating the relative values of this instance and value.
   * "A negative integer": This instance is shorter than value.
   * "Zero": This instance is equal to value.
   * "A positive integer": This instance is longer than value.
   */
  compareTo(value) {
    if (this._totalMilliseconds > value._totalMilliseconds) {
      return 1;
    }
    if (this._totalMilliseconds < value._totalMilliseconds) {
      return -1;
    }
    return 0;
  }
  /**
   * Returns a hash code for this instance.
   * @returns number - A 32-bit signed integer hash code.
   */
  getHashCode() {
    return this._totalMilliseconds ^ this._totalMilliseconds >> 32;
  }
  /**
   * Returns a value indicating whether this instance is equal to a specified TimeSpan object.
   * @param obj - An object to compare with this instance.
   * @returns boolean - true if obj represents the same time interval as this instance; otherwise, false.
   */
  equals(obj) {
    return this._totalMilliseconds == obj._totalMilliseconds;
  }
  /**
   * Compares two TimeSpan values and returns an integer that indicates whether the first value is shorter than, equal to, or longer than the second value.
   * @param t1 - The first time interval to compare.
   * @param t2 - The second time interval to compare.
   * @returns number - One of the following values.
   * "-1": t1 is shorter than t2.
   * "0": t1 is equal to t2.
   * "1": t1 is longer than t2.
   */
  static compare(t1, t2) {
    return t1.compareTo(t2);
  }
  /**
   * Returns a value that indicates whether two specified instances of TimeSpan are equal.
   * @param t1 - The first time interval to compare.
   * @param t2 - The second time interval to compare.
   * @returns boolean - true if the values of t1 and t2 are equal; otherwise, false.
   */
  static equals(t1, t2) {
    return t1.equals(t2);
  }
}
TimeSpan.millisecondsPerSecond = 1000.0;
TimeSpan.millisecondsPerMinute = 60000.0;
TimeSpan.millisecondsPerHour = 3600000.0;
TimeSpan.millisecondsPerDay = 86400000.0;

class NumberParsingResult {
  constructor(value = null) {
    this.value = 0;
    this.inputStr = "";
    this.acceptableStr = null;
    this.valueStr = "";
    this.parsed = false;
    if (value === null || value === undefined) {
      return;
    }
    this.value = value;
    this.valueStr = value.toString();
    this.inputStr = value.toString();
    this.acceptableStr = value.toString();
    this.parsed = true;
  }
}
class NumberUtility {
  static compare(x, y, inverse = false) {
    if (x < y) {
      return inverse ? 1 : -1;
    }
    if (x > y) {
      return inverse ? -1 : 1;
    }
    return 0;
  }
  static parse(str, allowFloat = true, maxLength = 10) {
    const info = new NumberParsingResult();
    info.inputStr = str;
    const escapedStr = str.replace(/([\n\r' ])/gm, "").replace(/([,])/gm, ".");
    const zeroValues = [".", "-", "+", "-.", "+."];
    let value = zeroValues.includes(escapedStr) ? 0 : Number(escapedStr);
    const parsed = !Number.isNaN(value) && Number.isFinite(value) && !escapedStr.includes("e") && !escapedStr.includes("E") && escapedStr.length <= maxLength && (allowFloat || Math.trunc(value) === value);
    const isAcceptableStr = parsed && (escapedStr.length === 0 || /^[-+]?[\d]*[.,]?[\d]*$/.test(escapedStr));
    value = parsed ? value : 0;
    const valueStr = parsed ? value.toString() : "";
    const acceptableStr = isAcceptableStr ? escapedStr : parsed ? valueStr : null;
    info.parsed = parsed;
    info.value = value;
    info.valueStr = valueStr;
    info.acceptableStr = acceptableStr;
    return info;
  }
  static resolveFormat(step, format, defaultFormat = null) {
    format = format || defaultFormat || "";
    if (format === "" && step != null) {
      format = step >= 0.1 && step < 1 ? "0.0" : step <= 0.01 ? "0.00" : "0";
    } else if (format && (step === null || step === undefined)) {
      const item = this._formats.find(item => item.format === format) || null;
      if (item) {
        return item;
      }
    }
    step = step || 1;
    return {
      step,
      format
    };
  }
}
NumberUtility._formats = [{
  format: "C",
  step: 0.01
}, {
  format: "c",
  step: 0.01
}, {
  format: "0.00",
  step: 0.01
}, {
  format: "0.00%",
  step: 0.01
}, {
  format: "0.0",
  step: 0.1
}, {
  format: "0.0%",
  step: 0.1
}, {
  format: "0",
  step: 1
}, {
  format: "n",
  step: 1
}, {
  format: "N",
  step: 1
}, {
  format: "%",
  step: 1
}, {
  format: "N%",
  step: 1
}, {
  format: "0%",
  step: 1
}];

class BoolUtility {
  static compare(x, y, inverse = false) {
    if (x < y) {
      return inverse ? 1 : -1;
    }
    if (x > y) {
      return inverse ? -1 : 1;
    }
    return 0;
  }
}

const ObjectType = "object";
class TypeConverter {
  static getServiceType(from, to) {
    const fromType = ServiceProvider$1.resolveServiceType(from);
    const toType = ServiceProvider$1.resolveServiceType(to);
    return `typeConverter:${fromType}:${toType}`;
  }
  addConverter(from, to, converter) {
    const fullName = TypeConverter.getServiceType(from, to);
    ServiceProvider$1.addSingleton(fullName, converter);
  }
  addObjectConverter(to, converter) {
    this.addConverter(ObjectType, to, converter);
  }
  getConverter(from, to) {
    const fullName = TypeConverter.getServiceType(from, to);
    return ServiceProvider$1.getService(fullName, false);
  }
  getObjectConverter(to) {
    return this.getConverter(ObjectType, to);
  }
  getRequiredConverter(from, to) {
    const fullName = TypeConverter.getServiceType(from, to);
    return ServiceProvider$1.getRequiredService(fullName, false);
  }
  getRequiredObjectConverter(to) {
    return this.getRequiredConverter(ObjectType, to);
  }
  canConvert(from, to) {
    const converter = this.getConverter(from, to) || this.getObjectConverter(to);
    return converter != null;
  }
  convert(from, to, defaultValue = null) {
    const converter = this.getConverter(from, to) || this.getObjectConverter(to);
    const value = converter != null ? typeof converter === "function" ? converter(from) : converter.convert(from) : null;
    return value != null ? value : defaultValue;
  }
}
const typeConverter = new TypeConverter();
function ObjectConverter(to) {
  return function decorator(target, propertyKey, descriptor) {
    const method = descriptor.value;
    if (to == null) {
      to = method.apply(target, [{}]);
    }
    if (to != null) {
      typeConverter.addObjectConverter(to, item => method.apply(target, [item]));
    }
  };
}

const StringType = "string";
function ToString(converter) {
  return constructor => {
    // implement class decorator here, the class decorator
    // will have access to the decorator arguments (filter)
    // because they are  stored in a closure
    typeConverter.addConverter(constructor, StringType, converter);
  };
}
class StringConverter {
  convert(item) {
    return this.toString(item);
  }
  toString(item, format) {
    if (item == null) {
      return "";
    }
    switch (typeof item) {
      case "string":
        return item;
      case "bigint":
      case "number":
      case "boolean":
        return item.toString();
    }
    if (Array.isArray(item)) {
      return item.length.toString();
    }
    const converter = this.getConverter(item);
    if (converter != null && converter !== this && converter !== this.toString) {
      return typeof converter === "function" ? converter(item, format) : converter.toString(item, format);
    }
    if (format) {
      if (typeof format === "function") {
        return format(item);
      }
      const enumProvider = ServiceProvider$1.findEnumProvider();
      if (enumProvider && enumProvider.isEnum(format)) {
        return enumProvider.getEnumText(format, item);
      }
      return Utility$1.format(`{0:${format}}`, item);
    }
    return typeof item.toString === "function" ? item.toString() : item;
  }
  addConverter(from, converter) {
    typeConverter.addConverter(from, StringType, converter);
  }
  addObjectConverter(converter) {
    typeConverter.addObjectConverter(StringType, converter);
  }
  getConverter(from) {
    return typeConverter.getConverter(from, StringType);
  }
  getObjectConverter() {
    return typeConverter.getObjectConverter(StringType);
  }
  getRequiredConverter(from) {
    return typeConverter.getRequiredConverter(from, StringType);
  }
  getRequiredObjectConverter() {
    return typeConverter.getRequiredObjectConverter(StringType);
  }
  canConvert(from) {
    return typeConverter.canConvert(from, StringType);
  }
}
var StringConverter$1 = new StringConverter();

class BaseTransformProvider {
  get selectListItemType() {
    if (this._selectListItemType == null) {
      const selectListItem = this.createSelectListItem("", "", "");
      this._selectListItemType = TypeResolver$1.resolve(selectListItem);
    }
    return this._selectListItemType;
  }
  constructor() {
    this._selectListItemType = null;
    // register the service
    ServiceProvider$1.addSingleton(this);
    // register converters
    // object to string converters:
    StringConverter$1.addObjectConverter((item, format) => this.toString(item, format));
    // object to ISelectListItem and SelectListItem converters
    typeConverter.addObjectConverter("ISelectListItem", item => this.toSelectListItem(item));
    typeConverter.addObjectConverter(this.selectListItemType, item => this.toSelectListItem(item));
  }
  initialize() {
    // do nothing
  }
  getType() {
    return "ITransformProvider";
  }
  locationToString(location) {
    return location != null ? [location.address, location.postalCode, location.city].filter(item => !!item).join(", ") : "";
  }
  toString(item, format) {
    if (item == null) {
      return "";
    }
    if (item instanceof GeoLocation || item.isGeoLocation) {
      return this.locationToString(item);
    }
    return StringConverter$1.toString(item, format);
  }
  toSelectListItem(item) {
    var _a;
    if (typeof item === "number") {
      const _value = item.toString();
      return this.createSelectListItem(_value, _value, "");
    }
    if (typeof item === "string") {
      return this.createSelectListItem(item, item, "");
    }
    const converter = (_a = typeConverter.getConverter(item, "ISelectListItem")) !== null && _a !== void 0 ? _a : typeConverter.getConverter(item, this.selectListItemType);
    if (converter != null && converter !== this.toSelectListItem) {
      return typeof converter === "function" ? converter(item) : converter.convert(item);
    }
    const value = Utility$1.findStringValueByAccessor(item, ["value"]);
    const id = Utility$1.findValueByAccessor(item, ["id", "code"]);
    const name = Utility$1.findStringValueByAccessor(item, ["name", "text", "label"]);
    const subtext = Utility$1.findStringValueByAccessor(item, ["subtext", "description"]);
    const groupName = Utility$1.findStringValueByAccessor(item, ["group", "group.name"]);
    const favorite = Utility$1.findStringValueByAccessor(item, "favorite") === "true";
    const itemValue = value ? value : id != null ? id.toString() : name ? name : Utility$1.getComponentId();
    return this.createSelectListItem(itemValue, name !== null && name !== void 0 ? name : "", subtext !== null && subtext !== void 0 ? subtext : "", groupName, favorite);
  }
}

var $ = _export;
var uncurryThis$1 = functionUncurryThis;
var isArray = isArray$2;

var nativeReverse = uncurryThis$1([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});

class BaseEnumProvider {
  constructor() {
    // #region Private/Protected
    this._localizer = null;
    ServiceProvider$1.addSingleton(this);
  }
  getEnumLocalizedName(enumType, enumName) {
    return `Enum.${enumType}.${enumName}`;
  }
  getEnumLocalizedDescription(enumType, enumName) {
    const itemName = `Enum.${enumType}.${enumName}.Description`;
    return this.localizer.contains(itemName) ? itemName : "";
  }
  transform(enumSymbol, enumType, enumValue) {
    const value = enumValue;
    const enumName = enumSymbol[value];
    const text = this.getEnumLocalizedName(enumType, enumName);
    const subtext = this.getEnumLocalizedDescription(enumType, enumName);
    return this.createSelectListItem(value.toString(), text, subtext);
  }
  getItems(enumSymbol, enumType, reverse = false) {
    const items = this.getValues(enumSymbol, reverse);
    return items.map(value => this.transform(enumSymbol, enumType, value));
  }
  get localizer() {
    if (this._localizer) {
      return this._localizer;
    }
    this._localizer = ServiceProvider$1.findLocalizer();
    if (this._localizer) {
      return this._localizer;
    }
    throw new Error("EnumHelper. Localizer is not registered.");
  }
  // #endregion
  initialize() {
    // do nothing
  }
  getType() {
    return "IEnumProvider";
  }
  getEnumItems(enumName, selectedValues, reverse) {
    const functionName = `get${enumName}Items`;
    const getter = this[functionName];
    const items = getter ? getter.call(this, !!reverse) : [];
    if (selectedValues != null && selectedValues.length > 0 && items.length > 0) {
      selectedValues.forEach(value => {
        const selectedItem = items.find(item => item.value === value.toString());
        if (selectedItem) {
          selectedItem.selected = true;
        }
      });
    }
    return items;
  }
  getEnumItem(enumName, value) {
    const values = this.getEnumItems(enumName);
    const enumValue = value.toString();
    const item = values.find(item => item.value === enumValue) || null;
    if (item == null) throw Error(`Select list item with value "${value}" for enum "${enumName}" cannot be found at BaseEnumProvider.getEnumItem.`);
    return item;
  }
  getEnumText(enumName, value) {
    const item = this.getEnumItem(enumName, value);
    return this.localizer.get(item.text);
  }
  getEnumName(enumName, value) {
    return this.getEnumItem(enumName, value).text;
  }
  isEnum(typeName) {
    return this.types.includes(typeName);
  }
  getValues(enumSymbol, reverse = false) {
    let items = Object.values(enumSymbol);
    if (reverse) {
      items = items.reverse();
    }
    return items.filter(value => !isNaN(value)).map(value => value);
  }
}

class PwaHelper {
  constructor() {
    this._deferredPrompt = null;
    this._initializeCallback = null;
    this._accepted = false;
  }
  onBeforeInstallPrompt(e) {
    // Prevent the mini info bar from appearing on mobile
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this._deferredPrompt = e;
    // Callback
    if (this._initializeCallback) {
      this._initializeCallback();
      this._initializeCallback = null;
    }
  }
  installAsync() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this._deferredPrompt) {
        // Show the install prompt
        yield this._deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        const result = yield this._deferredPrompt.userChoice;
        if (result.outcome === "accepted") {
          this._accepted = true;
          return true;
        }
      }
      return false;
    });
  }
  get initialized() {
    return !!this._deferredPrompt;
  }
  get canBeInstalled() {
    return this.initialized && !this._accepted;
  }
  subscribe(initializeCallback) {
    if (this.initialized) {
      initializeCallback();
    } else {
      this._initializeCallback = initializeCallback;
    }
  }
}
var PwaHelper$1 = new PwaHelper();

class BaseAsserter {
  constructor(value, name = null, error = null) {
    this._value = value;
    this._name = typeof name === "string" ? name : "value";
    this._error = error instanceof TypeError ? error : null;
  }
  assert(predicate, errorMessage) {
    if (this._error) {
      return;
    }
    if (!predicate(this._value)) {
      this._error = new TypeError(`${this._name} ${errorMessage}`);
    }
  }
  get getValue() {
    if (this._error) {
      throw this._error;
    }
    return this._value;
  }
  get getIsSuccess() {
    return this._error === null;
  }
}
class UnknownAsserter extends BaseAsserter {
  constructor(value, name = null, error = null) {
    super(value, name, error);
  }
  get isBoolean() {
    this.assert(value => typeof value === "boolean", "is not a boolean");
    return new BooleanAsserter(this._value, this._name, this._error);
  }
  get isBigInt() {
    this.assert(value => typeof value === "bigint", "is not a bigint");
    return new BigIntAsserter(this._value, this._name, this._error);
  }
  get isNumber() {
    this.assert(value => typeof value === "number", "is not a number");
    return new NumberAsserter(this._value, this._name, this._error);
  }
  get isObject() {
    this.assert(value => typeof value === "object", "is not an object");
    return new MaybeNullObjectAsserter(this._value, this._name, this._error);
  }
  get isString() {
    this.assert(value => typeof value === "string", "is not a string");
    return new MaybeEmptyStringAsserter(this._value, this._name, this._error);
  }
  get isSymbol() {
    this.assert(value => typeof value === "symbol", "is not a symbol");
    return this;
  }
  get isUndefined() {
    this.assert(value => typeof value === "undefined", "is not undefined");
    return this;
  }
}
class BigIntAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
}
class BooleanAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
  get isFalse() {
    this.assert(value => value === false, "is not false");
    return this;
  }
  get isTrue() {
    this.assert(value => value === true, "is not true");
    return this;
  }
}
class NumberAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
}
class MaybeNullObjectAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
  get isNull() {
    this.assert(value => value === null, "is not null");
    return this;
  }
  get isNotNull() {
    this.assert(value => value !== null, "is null");
    return new ObjectAsserter(this._value, this._name, this._error);
  }
}
class ObjectAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
  get isArray() {
    this.assert(value => Array.isArray(value), "is not an array");
    return new MaybeEmptyArrayAsserter(this._value, this._name, this._error);
  }
  isInstanceOf(constructor) {
    this.assert(value => value instanceof constructor, `is not an instance of ${constructor === null || constructor === void 0 ? void 0 : constructor.name}`);
    return this;
  }
}
class MaybeEmptyArrayAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
  get isEmpty() {
    this.assert(value => value.length <= 0, "is not empty");
    return this;
  }
  get isNotEmpty() {
    this.assert(value => value.length > 0, "is empty");
    return new ArrayAsserter(this._value, this._name, this._error);
  }
}
class ArrayAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
  all(predicate) {
    this.assert(array => array.every(value => predicate(value)), ": not all values fulfill the predicate");
    return this;
  }
  any(predicate) {
    this.assert(array => array.some(value => predicate(value)), ": no value fulfills the predicate");
    return this;
  }
  none(predicate) {
    this.assert(array => !array.some(value => predicate(value)), ": all values fulfill the predicate");
    return this;
  }
}
class MaybeEmptyStringAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
  }
  get isEmpty() {
    this.assert(value => value === "", "is not empty");
    return this;
  }
  get isNotEmpty() {
    this.assert(value => value !== "", "is empty");
    return new StringAsserter(this._value, this._name, this._error);
  }
}
class StringAsserter extends BaseAsserter {
  constructor(value, name, error) {
    super(value, name, error);
    this.whitespaceRegexp = /^\s+$/;
  }
  get isWhitespace() {
    this.assert(value => this.whitespaceRegexp.test(value), "is not empty");
    return this;
  }
  get isNotWhitespace() {
    this.assert(value => !this.whitespaceRegexp.test(value), "is not empty");
    return this;
  }
}
/**
 * Start performing assertions on a value.
 * @param value Value to perform assertions against.
 * @param name Name of the value. Used in error messages.
 */
function assert(value, name = null) {
  return new UnknownAsserter(value, name);
}

var call = functionCall;
var uncurryThis = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$j;
var isNullOrUndefined = isNullOrUndefined$7;
var requireObjectCoercible = requireObjectCoercible$b;
var speciesConstructor = speciesConstructor$3;
var advanceStringIndex = advanceStringIndex$3;
var toLength = toLength$a;
var toString = toString$d;
var getMethod = getMethod$6;
var regExpExec = regexpExecAbstract;
var stickyHelpers = regexpStickyHelpers;
var fails = fails$x;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var push = uncurryThis([].push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length !== 4 ||
  'ab'.split(/(?:ab)*/).length !== 2 ||
  '.'.split(/(.?)(.?)/).length !== 4 ||
  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 ||
  ''.split(/.?/).length;

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
  } : nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);

      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
      }

      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');
      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

/**
 * Base class for localizers.
 */
class BaseLocalizer {
  /**
   * @param supportedLanguages A list of supported languages.
   * @param defaultLanguageCode Language code of the default language (see {@link ILanguage.code}).
   */
  constructor(supportedLanguages, defaultLanguageCode) {
    this._items = new Dictionary(); // Language code -> Key -> Localized value
    this._supportedLanguages = supportedLanguages;
    this._supportedLanguageCodes = supportedLanguages.map(language => language.code);
    this._defaultLanguageCode = defaultLanguageCode;
    this._languageCode = defaultLanguageCode;
    ServiceProvider$1.addSingleton(this);
  }
  /**
   * @return A list of languages supported by the {@link BaseLocalizer}.
   */
  getSupportedLanguages() {
    return this._supportedLanguages;
  }
  /**
   * @return A list of language codes supported by the {@link BaseLocalizer}.
   * @see ILanguage.code
   */
  getSupportedLanguageCodes() {
    return this._supportedLanguageCodes;
  }
  /**
   * @return Language code of the currently selected language.
   * @see ILanguage.code
   */
  getLanguage() {
    return this._languageCode;
  }
  /**
   * @return Language code of the {@link BaseLocalizer}'s default language.
   * @see ILanguage.code
   */
  getDefaultLanguage() {
    return this._defaultLanguageCode;
  }
  /**
   * Get all localized values of a language.
   *
   * @param languageCode Language code of the language which localized values to get (see {@link ILanguage.code}).
   * @return Localized values of the given language.
   */
  getLanguageItems(languageCode) {
    let languageItems = this._items.getValue(languageCode);
    if (!languageItems) {
      languageItems = new Dictionary();
      this._items.setValue(languageCode, languageItems);
    }
    return languageItems;
  }
  /**
   * Set a localized value.
   *
   * @param key Key which value to set.
   * @param languageCode Language code of the language which value to set (see {@link ILanguage.code}).
   * @param value Value to set.
   */
  setItem(key, languageCode, value) {
    const languageItems = this.getLanguageItems(languageCode);
    languageItems.setValue(key, value);
  }
  /**
   * Set multiple different languages localized values which have the same key.
   *
   * @param key Key which values to set.
   * @param params Collection of Language code - Localized value pairs.
   */
  set(key, ...params) {
    params.map(item => this.setItem(key, item.language, item.value));
  }
  /**
   * Does nothing.
   */
  initialize() {
    // do nothing
  }
  /**
   * Find a language with the given language code.
   * If no language is found, returns the default language.
   *
   * @param languageCode Language code of the language to find (see {@link ILanguage.code}).
   * @return A language with the given language code, or the default language.
   */
  findLanguage(languageCode) {
    const language = languageCode ? this.getSupportedLanguages().find(language => language.code === languageCode) : undefined;
    return language || this.findLanguage(this.getDefaultLanguage());
  }
  /**
   * A list of language codes supported by the {@link BaseLocalizer}.
   * @see ILanguage.code
   */
  get supportedLanguageCodes() {
    return this.getSupportedLanguageCodes();
  }
  /**
   * Language code of the {@link BaseLocalizer}'s default language.
   * @see ILanguage.code
   */
  get defaultLanguage() {
    return this.getDefaultLanguage();
  }
  // ILocalizer
  get language() {
    return this.getLanguage();
  }
  get supportedLanguages() {
    return this.getSupportedLanguages();
  }
  getValue(languageCode, key, ...params) {
    let value = null;
    if (key) {
      const languageItems = this.getLanguageItems(languageCode);
      value = languageItems.getValue(key);
      if (value) {
        const lines = value.split(AthenaeumConstants.newLineRegex);
        value = lines.join("\n");
      }
    }
    value = value || key || "";
    return Utility$1.format(value, ...params);
  }
  get(key, ...params) {
    return this.getValue(this.getLanguage(), key, ...params);
  }
  contains(key, languageCode) {
    if (key) {
      const defaultLanguageCode = languageCode || this.getDefaultLanguage();
      const languageItems = this._items.getValue(defaultLanguageCode);
      return languageItems != null && languageItems.containsKey(key);
    }
    return false;
  }
  setLanguage(languageCode) {
    if (this._languageCode !== languageCode) {
      if (!this._supportedLanguageCodes.includes(languageCode)) throw Error(`Unsupported language code "${languageCode}".`);
      this._languageCode = languageCode;
      return true;
    }
    return false;
  }
  // IService
  getType() {
    return "ILocalizer";
  }
}

export { ArrayExtensions, ArrayUtility, AthenaeumConstants, BaseEnumProvider, BaseLocalizer, BaseTransformProvider, BoolUtility, DateExtensions, DateUtility, FileModel, GeoCoordinate, GeoLocation, HashCodeUtility, NumberExtensions, NumberParsingResult, NumberUtility, ObjectConverter, PwaHelper$1 as PwaHelper, ServiceProvider$1 as ServiceProvider, SortDirection, StringConverter$1 as StringConverter, StringExtensions, StringUtility, TimeSpan, ToString, typeConverter as TypeConverter, TypeResolver$1 as TypeResolver, Utility$1 as Utility, assert };
